<template>
  <div class="flex-1 p-4">
    <div class="text-transparent">{{reload}}</div>
    <div class="col-span-full flex">
      <PrimaryButton v-if="!loading&&requestPost.employmentClass&&requestPost.employmentClass[0]=='退職'" text="退職届PDF" class="bg-yellow-600" @click="resignationDL()"></PrimaryButton>
      <div v-else-if="loading" class="text-gray-700 my-2 animate-pulse">退職届生成中...</div>
      <!-- 社員の名札（ユーザーマスタから選んで作る。未登録なら作れない） -->
      <PrimaryButton v-if="requestPost.employmentRegularStaff" text="名札作成" class="bg-teal-600 hover:bg-teal-700" v-tooltip="'社員の名札を作る（ユーザーマスタに登録済みの人から選ぶ）'" @click="openNameplate()">
        <Icon slot="before" iconName="Identification" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
      </PrimaryButton>
      <!-- 人事部、管理者のみ -->
      <div class="ml-auto" v-if="auth">
        <div v-tooltip="'人事部、管理者のみ設定可能'" class="w-auto py-0 text-sm text-right mr-3 text-indigo-800 hover:text-indigo-500 cursor-pointer" @click="openChatRoomId=true">Chatwork通知設定</div>
      </div>
    </div>

    <!-- <InputGroupLabel
      name="categoryTitle"
      caption="雇い入れ"
      class="mt-4"
    /> -->

    <!-- 正社員の場合 -->
    <div class="col-span-full" v-if="requestPost.employmentRegularStaff&&requestPost.employmentClass&&requestPost.employmentClass[0]=='社員入社'">
      <!-- 新卒・中途 -->
      <div v-if="requestPost.employmentNewGrad" class="font-bold text-xl text-gray-600 mb-3">
        新卒
      </div>
      <div v-else class="font-bold text-xl text-gray-600 mb-3">
        中途
      </div>
    </div>

    <!-- 清掃員の場合 -->
    <div v-else-if="!requestPost.employmentRegularStaff" class="font-bold text-xl text-gray-600 mb-3 col-span-full">
      清掃員
    </div>

    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-6 self-start mt-3" style="min-width: 500px;">

      <div v-if="!requestPost.employmentRegularStaff&&!requestPost._id" class="text-xs font-bold text-red-700 mb-3 sm:col-span-full">
        清掃員の新規入社は面接タスク完了時に自動で作られます
        <span class="text-blue-700 cursor-pointer pl-5 text-xs font-bold" @click="newEnterForCD">手動で完了前に作る場合はこちらをクリック</span>
      </div>

      <div class="sm:col-span-full" :class="requestPost.employmentRegularStaff?'':'six-selection'">
        <SelectionButton2
          name="employmentClass"
          caption="種別"
          v-model="requestPost.employmentClass"
          :item="classSelections"
          :multiSelect="false"
          :required="true"
          :error="!requireValidateArr('employmentClass', '種別').result"
          :errorMessage="requireValidateArr('employmentClass', '種別').message"
          :disabled="referenceMode||!requestPost.notNewEnter"
          @change="changeEmploymentClass($event)"
        />
      </div>

      <!-- 契約変更の場合 -->
      <div class="sm:col-span-full"  v-if="isShow('変更もしくは終了')">
        <div class="text-xs mb-1 font-bold text-gray-700">変更もしくは終了
          <span class="text-red-500"> * </span>
        </div>
        <div class="flex text-sm border border-blue-800 rounded text-center cursor-pointer w-fit" :class="referenceMode?'cursor-not-allowed':''">
          <div @click="clickModifyType(1)" :class="requestPost.modifyType==1?'bg-blue-800 text-white font-bold':'text-gray-600 bg-white'" class="rounded-l w-115px py-2 px-3 border-r">契約内容変更</div>
          <div @click="clickModifyType(2)" :class="requestPost.modifyType==2?'bg-blue-800 text-white font-bold':'text-gray-600 bg-white'" class="rounded-r w-115px py-2 px-3">作業終了</div>
        </div>
      </div>

      <div class="sm:col-span-full" v-if="isShow('退職日')">
        <WmsDateInput
          v-if="!referenceMode"
          name="employmentRetirementDate"
          caption="退職日"
          v-model="requestPost.employmentRetirementDate"
          :clearable="true"
          :required="isRequired('退職日')"
          :error="!requireValidateStr('employmentRetirementDate', '退職日').result"
          :errorMessage="requireValidateStr('employmentRetirementDate', '退職日').message"
          @change="setLimitDate()"
        />
        <WmsTextInput
          v-else
          name="employmentRetirementDate"
          caption="退職日"
          :disabled="true"
          v-model="requestPost.employmentRetirementDate"
          :required="isRequired('退職日')"
        />
      </div>

      <!-- 契約変更の場合、退職日を変更日という名称に変更2025-04 -->
      <div class="sm:col-span-full" v-if="isShow('変更日 ')">
        <WmsDateInput
          name="employmentRetirementDate"
          :caption="requestPost.modifyType==2?'作業終了日':'変更日'"
          v-model="requestPost.employmentRetirementDate"
          :class="requestPost.employmentRetirementDate&&requestPost.employmentClass&&(requestPost.employmentClass[0]=='契約変更'||requestPost.employmentClass[0]=='物件退職')?'i-bg-yellow-200':''"
          :clearable="true"
          :required="isRequired('変更日 ')"
          :error="!requireValidateStr('employmentRetirementDate', '変更日 ').result"
          :errorMessage="requireValidateStr('employmentRetirementDate', '変更日 ').message"
          @change="setLimitDate()"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full">
        <NumericTextInput2
          name="employmentStaffNumber"
          caption="社員番号"
          v-model="requestPost.employmentStaffNumber"
          :format="false"
          :disabled="referenceMode"
        />
      </div>

      <!-- 氏名 手入力 -->
      <div class="sm:col-span-full" v-if="isShow('氏名')&&requestPost.employmentClass&&['新規入社', '社員入社'].includes(requestPost.employmentClass[0])">
        <WmsTextInput
          name="employmentName"
          caption="氏名"
          v-model="requestPost.employmentName"
          :disabled="referenceMode"
          :required="isRequired('氏名')"
          :error="!requireValidateStr('employmentName', '氏名').result"
          :errorMessage="requireValidateStr('employmentName', '氏名').message"
          @change="setTitle()"
        />
      </div>
      <!-- 氏名 RPユーザーリスト -->
      <div class="sm:col-span-full" v-else-if="isShow('氏名')&&requestPost.employmentClass&&['社員退職'].includes(requestPost.employmentClass[0])">
        <WmsSuggestInput
          name="employmentName"
          caption="氏名"
          :required="isRequired('氏名')"
          :selectionItems="userList"
          displayField="nameStaff"
          v-model="requestPost.employmentName"
          :disabled="referenceMode"
          :error="!requireValidateStr('employmentName', '氏名').result"
          :errorMessage="requireValidateStr('employmentName', '氏名').message"
          @selected="staffSelected($event)"
          @blur="staffChanged()"
        >
        </WmsSuggestInput>
        <div class="font-bold text-blue-700 mt-1 text-xs ml-3">
          RPユーザーID ： {{ requestPost.employmentUserId }}
        </div>
      </div>
      <!-- 氏名 AKBS雇用指示リスト -->
      <div class="sm:col-span-full" v-else-if="isShow('氏名')">
        <WmsSuggestInput
          name="employmentName"
          caption="氏名"
          :required="isRequired('氏名')"
          :selectionItems="employmentNameList"
          displayField="nameStaff"
          v-model="requestPost.employmentName"
          :disabled="referenceMode"
          :error="!requireValidateStr('employmentName', '氏名').result"
          :errorMessage="requireValidateStr('employmentName', '氏名').message"
          @selected="staffSelected($event)"
          @blur="staffChanged()"
        >
        </WmsSuggestInput>
        <div v-if="requestPost.birthday" class="font-bold text-blue-700 mt-1 text-sm ml-3">
          生年月日：{{ requestPost.birthday }}
          <span class="pl-5">（{{ requestPost.age }}歳）</span>
        </div>
      </div>

      <div class="sm:col-span-full" v-if="isOther&&isShow('物件名')">
        <WmsSuggestInput
          name="employmentBuildingName"
          caption="物件名"
          :required="isRequired('物件名')"
          :selectionItems="employmentBuildingList"
          displayField="nameSite"
          v-model="requestPost.employmentBuildingName"
          :disabled="referenceMode"
          :error="!requireValidateStr('employmentBuildingName', '物件名').result"
          :errorMessage="requireValidateStr('employmentBuildingName', '物件名').message"
          @selected="siteSelected($event)"
          @blur="siteChanged()"
        >
          <!-- 検索アイコン -->
          <template #addon-content>
            <Icon
              iconName="Search"
              :clickable="true"
              class="w-4 h-4 mr-0.5"
              @click="openSiteModal()"
            />
          </template>
        </WmsSuggestInput>
      </div>

      <div class="sm:col-span-full" v-if="isOther&&isShow('物件名')">
        <WmsTextInput
          name="employmentSiteCode"
          caption="物件コード"
          v-model="requestPost.employmentSiteCode"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full" v-if="isOther&&isShow('物件名')">
        <WmsTextInput
          name="employmentSiteAddress"
          caption="物件住所"
          v-model="requestPost.employmentSiteAddress"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full" v-if="isOther">
        <WmsDateInput
          v-if="!referenceMode"
          name="employmentChangedDate"
          caption="変更日"
          v-model="requestPost.employmentChangedDate"
          :clearable="true"
          :required="isRequired('変更日')"
          :error="!requireValidateStr('employmentChangedDate', '変更日').result"
          :errorMessage="requireValidateStr('employmentChangedDate', '変更日').message"
        />
        <WmsTextInput
          v-else
          name="employmentChangedDate"
          caption="変更日"
          :disabled="true"
          v-model="requestPost.employmentChangedDate"
          :required="isRequired('変更日')"
        />
      </div>

      <div class="sm:col-span-full" v-if="isOther">
        <WmsTextInput
          name="employmentRemarks"
          caption="連絡事項"
          v-model="requestPost.employmentRemarks"
          :multiline="true"
          :rows="5"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('フリガナ')">
        <WmsTextInput
          name="employmentKana"
          caption="フリガナ"
          v-model="requestPost.employmentKana"
          :disabled="referenceMode"
          :required="isRequired('フリガナ')"
          :error="!requireValidateStr('employmentKana', 'フリガナ').result"
          :errorMessage="requireValidateStr('employmentKana', 'フリガナ').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('生年月日')">
        <WmsDateInput
          v-if="!referenceMode"
          name="employmentBirthDay"
          caption="生年月日"
          v-model="requestPost.employmentBirthDay"
          @change="ageCalculation"
          :clearable="true"
          :required="isRequired('生年月日')"
          :error="!requireValidateStr('employmentBirthDay', '生年月日').result"
          :errorMessage="requireValidateStr('employmentBirthDay', '生年月日').message"
        />
        <WmsTextInput
          v-else
          name="employmentBirthDay"
          caption="生年月日"
          :disabled="true"
          :required="isRequired('生年月日')"
          v-model="requestPost.employmentBirthDay"
        />
      </div>

      <div class="sm:col-span-full text-blue-800" v-if="isShow('生年月日')">
        <div v-if="requestPost.employmentBirthDay" class="mt-auto mb-2 mx-3 text-sm">
          和暦： {{ japaneseDate(requestPost.employmentBirthDay) }}
        </div>
      </div>

      <!-- 清掃員の場合、ここにも入社日 -->
      <div class="sm:col-span-full" v-if="isShow('入社日')&&!requestPost.employmentRegularStaff&&requestPost.employmentClass[0]!='物件追加'">
        <WmsDateInput
          v-if="!referenceMode"
          name="employmentHireDate"
          caption="入社日"
          v-model="requestPost.employmentHireDate"
          :clearable="true"
          :required="isRequired('入社日')"
          :error="!requireValidateStr('employmentHireDate', '入社日').result"
          :errorMessage="requireValidateStr('employmentHireDate', '入社日').message"
          @change="setLimitDate()"
        />
        <WmsTextInput
          v-else
          name="employmentHireDate"
          caption="入社日"
          :disabled="true"
          v-model="requestPost.employmentHireDate"
          :required="isRequired('入社日')"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('年齢')">
        <NumericTextInput2
          name="employmentAge"
          caption="年齢"
          maxLenght="3"
          v-model="requestPost.employmentAge"
          :disabled="referenceMode"
          :required="isRequired('年齢')"
          :error="!requireValidateStr('employmentAge', '年齢').result"
          :errorMessage="requireValidateStr('employmentAge', '年齢').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('性別')">
        <SelectionButton2
          name="employmentSex"
          caption="性別"
          v-model="requestPost.employmentSex"
          :item="sexSelections"
          :multiSelect="false"
          :disabled="referenceMode"
          :required="isRequired('性別')"
          :error="!requireValidateArr('employmentSex', '性別').result"
          :errorMessage="requireValidateArr('employmentSex', '性別').message"
        />
      </div>

      <div class="sm:col-span-3" v-if="isShow('郵便番号')">
        <WmsTextInput
          name="employmentPostCode"
          caption="郵便番号"
          placeholder="000-0000"
          v-model="requestPost.employmentPostCode"
          :disabled="referenceMode"
          :required="isRequired('郵便番号')"
          :error="!requireValidateStr('employmentPostCode', '郵便番号').result"
          :errorMessage="requireValidateStr('employmentPostCode', '郵便番号').message"
        />
      </div>
      <div class="sm:col-span-3" v-if="!referenceMode&&isShow('郵便番号')">
        <PrimaryButton text="住所検索" class="w-40 mx-2 bg-green-500" @click="addressSearch()">
        </PrimaryButton>

        <PrimaryButton text="住所から取得" class="w-40 bg-green-500" @click="postalCodeSearch()">
        </PrimaryButton>
      </div>

      <div class="sm:col-span-full" v-if="isShow('住所１')">
        <WmsTextInput
          name="employmentAddress1"
          caption="住所１"
          v-model="requestPost.employmentAddress1"
          :disabled="referenceMode"
          :required="isRequired('住所１')"
          :error="!requireValidateStr('employmentAddress1', '住所１').result"
          :errorMessage="requireValidateStr('employmentAddress1', '住所１').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('住所２')">
        <WmsTextInput
          name="employmentAddress2"
          caption="住所２"
          v-model="requestPost.employmentAddress2"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('固定電話')">
        <label for="employmentTel" class="block text-xs font-bold text-gray-700">固定電話</label>
          <div class="mt-1 flex relative">
            <input
              type="tel"
              name="employmentTel"
              v-model="requestPost.employmentTel"
              :disabled="referenceMode"
              class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded"
              :class="referenceMode?'bg-gray-200 cursor-not-allowed text-gray-500':''"
              @keypress="onKeyPressTel"
            />
          </div>
      </div>

      <div class="sm:col-span-full" v-if="isShow('携帯電話')">
        <label for="employmentMobile" class="block text-xs font-bold text-gray-700 relative">
          携帯電話
          <span v-if="isRequired('携帯電話')" class="absolute -top-0.5 ml-1 text-red-500"> * </span>
          <span v-if="errMobile" class="text-xs font-bold text-red-500 ml-5">{{ errMobile }}</span>
        </label>
        <div class="mt-1 flex relative">
          <InputIcon v-if="!requireValidateStr('employmentMobile', '携帯電話').result" iconName="ExclamationCircle" iconColor="red" :message="requireValidateStr('employmentMobile', '携帯電話').message" />
          <input
            type="tel"
            name="employmentMobile"
            v-model="requestPost.employmentMobile"
            :disabled="referenceMode"
            class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded"
            :class="referenceMode?'bg-gray-200 cursor-not-allowed text-gray-500':''"
            @keypress="onKeyPressTel"
          />
        </div>
      </div>

      <InputGroupLabel
        v-if="isShow('緊急連絡先')"
        name="categoryTitle"
        caption="緊急連絡先"
        class="mt-10"
      />

      <div class="sm:col-span-full" v-if="isShow('緊急連絡先')">
        <WmsTextInput
          name="employmentEmergencyContactKana"
          caption="フリガナ"
          v-model="requestPost.employmentEmergencyContactKana"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('緊急連絡先')">
        <WmsTextInput
          name="employmentEmergencyContact"
          caption="氏名"
          v-model="requestPost.employmentEmergencyContact"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('緊急連絡先')">
        <WmsTextInput
          name="employmentEmergencyRelationship"
          caption="御関係"
          v-model="requestPost.employmentEmergencyRelationship"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('緊急連絡先')">
        <WmsTextInput
          name="employmentEmergencyAddress"
          caption="住所"
          v-model="requestPost.employmentEmergencyAddress"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('緊急連絡先')">
        <label for="employmentEmergencyPhoneNumber" class="block text-xs font-bold text-gray-700">電話番号</label>
        <div class="mt-1 flex relative">
          <input
            type="tel"
            name="employmentEmergencyPhoneNumber"
            v-model="requestPost.employmentEmergencyPhoneNumber"
            :disabled="referenceMode"
            class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded"
            :class="referenceMode?'bg-gray-200 cursor-not-allowed text-gray-500':''"
            @keypress="onKeyPressTel"
          />
        </div>
      </div>

      <InputGroupLabel class="mt-1 mb-10" v-if="isShow('緊急連絡先')" />

      <div class="sm:col-span-full" v-if="requestPost.employmentClass.includes('新規入社')||requestPost.employmentClass.includes('再入社')">
        <NumericTextInput2
          name="employmentStaffNumber"
          caption="社員番号"
          v-model="requestPost.employmentStaffNumber"
          :format="false"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('入社日')">
        <WmsDateInput
          name="employmentHireDate"
          :caption="requestPost.employmentClass[0]=='物件追加'?'物件入社日':'入社日'"
          v-model="requestPost.employmentHireDate"
          :disabled="referenceMode"
          :clearable="true"
          :required="isRequired('入社日')"
          :error="!requireValidateStr('employmentHireDate', '入社日').result"
          :errorMessage="requireValidateStr('employmentHireDate', '入社日').message"
          @change="setLimitDate()"
        />
      </div>

      <div class="sm:col-span-full" v-if="!isOther&&isShow('物件名')">
        <WmsSuggestInput
          name="employmentBuildingName"
          caption="物件名"
          :required="isRequired('物件名')"
          :selectionItems="employmentBuildingList"
          displayField="nameSite"
          v-model="requestPost.employmentBuildingName"
          :disabled="referenceMode"
          :error="!requireValidateStr('employmentBuildingName', '物件名').result"
          :errorMessage="requireValidateStr('employmentBuildingName', '物件名').message"
          @selected="siteSelected($event)"
          @blur="siteChanged()"
        >
          <!-- 検索アイコン -->
          <template #addon-content>
            <Icon
              iconName="Search"
              :clickable="true"
              class="w-4 h-4 mr-0.5"
              @click="openSiteModal()"
            />
          </template>
        </WmsSuggestInput>
      </div>

      <div class="sm:col-span-full" v-if="!isOther&&isShow('物件名')">
        <WmsTextInput
          name="employmentSiteCode"
          caption="物件コード"
          v-model="requestPost.employmentSiteCode"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full" v-if="!isOther&&isShow('物件名')">
        <WmsTextInput
          name="employmentSiteAddress"
          caption="物件住所"
          v-model="requestPost.employmentSiteAddress"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('エリア')">
        <div class="text-xs text-gray-600 font-bold relative" style="margin-bottom:4px;">
          エリア <span v-if="isRequired('エリア')" class="absolute -top-0.5 ml-1 text-red-500"> * </span>
        </div>
        <div class="relative">
          <InputIcon v-if="!requireValidateStr('employmentArea', 'エリア').result" iconName="ExclamationCircle" iconColor="red" :message="requireValidateStr('employmentArea', 'エリア').message" />
          <select
              class="w-full rounded border-gray-300 text-sm"
              v-model="requestPost.employmentArea"
              :disabled="referenceMode"
              :class="referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':''"
          >
              <option v-for="(row, index) in areaSelections" :value="row" :key="index">
                  {{ row }}
              </option>
          </select>
        </div>
      </div>

      <div class="sm:col-span-full" v-if="isShow('得意先名')">
        <WmsSuggestInput
          name="employmentCustomer"
          caption="得意先名"
          :required="isRequired('得意先名')"
          :selectionItems="clientLists"
          :displayField="['clientName', 'clientDepartmentName']"
          v-model="requestPost.employmentCustomer"
          :disabled="referenceMode"
          :error="!requireValidateStr('employmentCustomer', '得意先名').result"
          :errorMessage="requireValidateStr('employmentCustomer', '得意先名').message"
          @selected="clientSelected"
          @change="clientNameChanged"
        >
          <template #addon-content>
            <Icon
              iconName="Search"
              :clickable="true"
              class="w-4 h-4 mr-0.5"
              @click="clientModal=true"
            />
          </template>
        </WmsSuggestInput>
        <!-- <WmsTextInput
          name="employmentCustomer"
          caption="得意先名"
          v-model="requestPost.employmentCustomer"
          :disabled="referenceMode"
          :required="isRequired('得意先名')"
          :error="!requireValidateStr('employmentCustomer', '得意先名').result"
          :errorMessage="requireValidateStr('employmentCustomer', '得意先名').message"
        /> -->
      </div>

      <div class="sm:col-span-full" v-if="isShow('得意先名')">
        <WmsTextInput
          name="clientFax"
          caption="FAX番号"
          v-model="requestPost.clientFax"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full five-selection" v-if="isShow('作業内容')">
        <SelectionButton2
          name="employmentSex"
          caption="作業内容"
          v-model="requestPost.employmentWorkTask"
          :item="workSelections"
          :multiSelect="false"
          :disabled="referenceMode"
          :required="isRequired('作業内容')"
          :error="!requireValidateArr('employmentWorkTask', '作業内容').result"
          :errorMessage="requireValidateArr('employmentWorkTask', '作業内容').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('得意先名')&&!(requestPost.employmentClass[0]&&requestPost.employmentClass[0]=='契約変更'&&requestPost.modifyType==1)">
        <div class="text-xs font-bold text-gray-700 mb-1">得意先へ連絡</div>
        <div class="flex">
          <PrimaryButton text="メール" size="normal py-1.5" class="mr-3 w-32" @click="opentMessageForClient(true)">
            <Icon slot="before" iconName="Mail" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
          </PrimaryButton>
          <PrimaryButton text="FAX" size="normal py-1.5" class="w-32" @click="opentMessageForClient(false)">
            <Icon slot="before" iconName="Printer" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
          </PrimaryButton>
        </div>
      </div>

      <div class="sm:col-span-full mt-10" v-if="isShow('時給')">
        <NumericTextInput2
          name="employmentHourlyWage"
          caption="時給"
          v-model="requestPost.employmentHourlyWage"
          @change = "limitHourlyWageInput"
          :disabled="referenceMode"
          :required="isRequired('時給')"
          :error="!requireValidateStr('employmentHourlyWage', '時給').result"
          :errorMessage="requireValidateStr('employmentHourlyWage', '時給').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('締め日')">
        <SelectionButton2
          name="employmentClosingDate"
          caption="締め日"
          v-model="requestPost.employmentClosingDate"
          :item="closingDate"
          :multiSelect="false"
          :disabled="referenceMode"
        />
      </div>

      <InputGroupLabel
        v-if="isShow('交通費')"
        name="categoryTitle"
        caption="交通費（不要であれば0を入力）"
        class="mt-10"
      />

      <div class="sm:col-span-full grid grid-cols-10" v-if="isShow('交通費')">
        <div class="sm:col-span-5 mr-5">
          <SelectionButton2
            name="employmentTrainType"
            caption="電車 区分"
            v-model="requestPost.employmentTrainType"
            :item="provisionSelections"
            :multiSelect="false"
            :disabled="referenceMode"
            :required="isRequired('電車 区分')"
            :error="!requireValidateArr('employmentTrainType', '電車 区分').result"
            :errorMessage="requireValidateArr('employmentTrainType', '電車 区分').message"
            @change="changeTrans('employmentTrainType', 'employmentTrainExpenses')"
          />
        </div>

        <div class="sm:col-span-5">
          <NumericTextInput2
            name="employmentTrainExpenses"
            caption="電車 交通費"
            maxLenght="5"
            v-model="requestPost.employmentTrainExpenses"
            :disabled="referenceMode"
            :required="isRequired('電車 交通費')"
            :error="!requireValidateStr('employmentTrainExpenses', '電車 交通費').result"
            :errorMessage="requireValidateStr('employmentTrainExpenses', '電車 交通費').message"
          />
        </div>
      </div>

      <div class="sm:col-span-full grid grid-cols-10" v-if="isShow('交通費')">
        <div class="sm:col-span-5 mr-5">
          <SelectionButton2
            name="employmentBusType"
            caption="バス 区分"
            v-model="requestPost.employmentBusType"
            :item="provisionSelections"
            :multiSelect="false"
            :disabled="referenceMode"
            :required="isRequired('バス 区分')"
            :error="!requireValidateArr('employmentBusType', 'バス 区分').result"
            :errorMessage="requireValidateArr('employmentBusType', 'バス 区分').message"
            @change="changeTrans('employmentBusType', 'employmentBusExpenses')"
          />
        </div>

        <div class="sm:col-span-5">
          <NumericTextInput2
            name="employmentBusExpenses"
            caption="バス 交通費"
            maxLenght="5"
            v-model="requestPost.employmentBusExpenses"
            :disabled="referenceMode"
            :required="isRequired('バス 交通費')"
            :error="!requireValidateStr('employmentBusExpenses', 'バス 交通費').result"
            :errorMessage="requireValidateStr('employmentBusExpenses', 'バス 交通費').message"
          />
        </div>
      </div>

      <div class="sm:col-span-full grid grid-cols-10" v-if="isShow('交通費')">
        <div class="sm:col-span-5 mr-5">
          <SelectionButton2
            name="employmentParkingType"
            caption="駐輪 区分"
            v-model="requestPost.employmentParkingType"
            :item="provisionSelections"
            :multiSelect="false"
            :disabled="referenceMode"
            :required="isRequired('駐輪 区分')"
            :error="!requireValidateArr('employmentParkingType', '駐輪 区分').result"
            :errorMessage="requireValidateArr('employmentParkingType', '駐輪 区分').message"
            @change="changeTrans('employmentParkingType', 'employmentParkingExpenses')"
          />
        </div>

        <div class="sm:col-span-5">
          <NumericTextInput2
            name="employmentParkingExpenses"
            caption="駐輪 交通費"
            maxLenght="5"
            v-model="requestPost.employmentParkingExpenses"
            :disabled="referenceMode"
            :required="isRequired('駐輪 交通費')"
            :error="!requireValidateStr('employmentParkingExpenses', '駐輪 交通費').result"
            :errorMessage="requireValidateStr('employmentParkingExpenses', '駐輪 交通費').message"
          />
        </div>
      </div>

      <InputGroupLabel class="mt-1 mb-10" v-if="isShow('交通費')" />

      <div v-for="(aw, i) in requestPost.employmentAppliedWork" v-bind:key="'AppliedWork' + i"  class="sm:col-span-full">
        <div class="flex" v-if="isShow('ご応募いただいた勤務曜日')">
          <div id="employmentAppliedWorkDays" class="mr-3">
            <SelectionButton2
              name="employmentAppliedWorkDays"
              caption="ご応募いただいた勤務曜日"
              v-model="aw.days"
              :item ="daysSelection"
              :multiSelect="true"
              :disabled="referenceMode"
              :required="isRequired('ご応募いただいた勤務曜日')"
              :error="!requireValidateArr2(aw.days, 'ご応募いただいた勤務曜日').result"
              :errorMessage="requireValidateArr2(aw.days, 'ご応募いただいた勤務曜日').message"
            />
          </div>

          <div>
            <div class="flex">
              <div class="">
                <WmsTimeInput2
                  name="employmentAppliedWorkStartTime"
                  caption="勤務時間"
                  v-model="aw.startTime"
                  class="time"
                  :clearable="true"
                  :hourItems="hourItems"
                  :minuteItems="minuteItems"
                  :disabled="referenceMode"
                  :required="isRequired('勤務時間')"
                  :error="!requireValidateArr2(aw.startTime, '勤務時間').result||!requireValidateArr2(aw.endTime, '勤務時間').result"
                  :errorMessage="requireValidateArr2(aw.startTime, '勤務時間').message"
                />
              </div>
              <div class="mt-6 mx-1 font-bold">～</div>
              <div class="mt-4">
                <WmsTimeInput2
                  name="employmentAppliedWorkEndTime"
                  caption=""
                  v-model="aw.endTime"
                  class="time"
                  :clearable="true"
                  :hourItems="hourItems"
                  :minuteItems="minuteItems"
                  :disabled="referenceMode"
                />
              </div>

              <!-- 勤務時間 -->
              <div class="text-sm ml-2 mt-auto mb-1 min-w-fit">
                ( {{ getWorkingHours(i) }} h )
              </div>
            </div>

            <div class="text-xs mt-1 text-gray-700 font-bold">休憩時間 ※6時間以上の場合のみ</div>
            <div class="flex">
              <div class="">
                <WmsTimeInput2
                  name="employmentAppliedWorkStartBreakTime"
                  caption=""
                  v-model="aw.startBreakTime"
                  class="time"
                  :clearable="true"
                  :hourItems="hourItems"
                  :minuteItems="minuteItems"
                  :disabled="referenceMode"
                />
              </div>
              <div class="mt-4 mx-1 font-bold">～</div>
              <div class="">
                <WmsTimeInput2
                  name="employmentAppliedWorkEndBreakTime"
                  caption=""
                  v-model="aw.endBreakTime"
                  class="time"
                  :clearable="true"
                  :hourItems="hourItems"
                  :minuteItems="minuteItems"
                  :disabled="referenceMode"
                />
              </div>
            </div>
          </div>

          <!-- 勤務曜日・時間 追加ボタン -->
          <div class="addButton-contents mt-auto ml-auto" v-if="!referenceMode && i==0">
            <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'追加'" @click="addAppliedWork()">
              <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
          <!-- 勤務曜日・時間 削除ボタン -->
          <div class="mt-auto text-right ml-auto" v-else-if="!referenceMode">
            <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeAppliedWork(i)">
              <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
        </div>
      </div>

      <!-- <div>週の合計実働時間（休憩含まない）：{{ totalWorkHours }}</div> -->

      <div class="sm:col-span-full five-selection" v-if="isShow('祝日区分')">
        <SelectionButton2
          name="employmentHolidayType"
          caption="祝日区分"
          v-model="requestPost.employmentHolidayType"
          :item="holidayType"
          :multiSelect="false"
          :disabled="referenceMode"
          :required="isRequired('祝日区分')"
          :error="!requireValidateArr('employmentHolidayType', '祝日区分').result"
          :errorMessage="requireValidateArr('employmentHolidayType', '祝日区分').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('ゴミ搬出')">
        <SelectionButton2
          name="employmentTrashRemoval"
          caption="ゴミ搬出"
          v-model="requestPost.employmentTrashRemoval"
          :item="yesNo"
          :multiSelect="false"
          :disabled="referenceMode"
          :required="isRequired('ゴミ搬出')"
          :error="!requireValidateArr('employmentTrashRemoval', 'ゴミ搬出').result"
          :errorMessage="requireValidateArr('employmentTrashRemoval', 'ゴミ搬出').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('必要な書類')">
        <SelectionButton2
          name="employmentMaterial"
          caption="必要な書類"
          v-model="requestPost.employmentMaterial"
          :item="materialSelections"
          :multiSelect="true"
          :disabled="referenceMode"
          :required="isRequired('必要な書類')"
          :error="!requireValidateArr('employmentMaterial', '必要な書類').result"
          :errorMessage="requireValidateArr('employmentMaterial', '必要な書類').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('履歴書')">
        <label class="block text-xs font-bold text-gray-700 relative">
          添付資料（履歴書）<span v-if="isRequired('履歴書')" class="absolute -top-0.5 ml-1 text-red-500"> * </span>
        </label>
        <div class="mt-1">
          <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
            <WmsAttachment
              name="employmentDocument"
              style="max-width: none!important;"
              :value="requestPost.employmentDocument"
              :disabled="referenceMode"
              @change="attachmentChange('employmentDocument', $event)"
              :errorMessage="requireValidateAttach('employmentDocument', '履歴書').message"
            />
          </div>
        </div>
      </div>

      <!-- ここから社員の項目 -start- -->

      <div class="sm:col-span-full five-selection" v-if="isShow('部署')">
        <SelectionButton2
          name="employmentDepartmentId"
          caption="部署"
          v-model="requestPost.employmentDepartmentId"
          :item="departmentItems"
          :multiSelect="false"
          :disabled="referenceMode"
          :required="isRequired('部署')"
          :error="!requireValidateArr('employmentDepartmentId', '部署').result"
          :errorMessage="requireValidateArr('employmentDepartmentId', '部署').message"
          @change="requestPost.employmentDepartment=$event.text"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('同行者')">
        <WmsTextInput
          name="employmentCompanion"
          caption="同行者"
          v-model="requestPost.employmentCompanion"
          :disabled="referenceMode"
          :required="isRequired('同行者')"
          :error="!requireValidateStr('employmentCompanion', '同行者').result"
          :errorMessage="requireValidateStr('employmentCompanion', '同行者').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('週休●日制')">
        <SelectionButton2
          name="employmentWeekly"
          caption="週休●日制"
          v-model="requestPost.employmentWeekly"
          :item="weeklyHolidayItems"
          :multiSelect="false"
          :disabled="referenceMode"
          :required="isRequired('週休●日制')"
          :error="!requireValidateArr('employmentWeekly', '週休●日制').result"
          :errorMessage="requireValidateArr('employmentWeekly', '週休●日制').message"
        />
      </div>

      <div class="sm:col-span-full seven-selection" v-if="isShow('公休日')">
        <SelectionButton2
          name="employmentPublicHoliday"
          caption="公休日"
          v-model="requestPost.employmentPublicHoliday"
          :item="daysSelection"
          :multiSelect="true"
          :disabled="referenceMode"
          :required="isRequired('公休日')"
          :error="!requireValidateArr('employmentPublicHoliday', '公休日').result"
          :errorMessage="requireValidateArr('employmentPublicHoliday', '公休日').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('引越し費用')">
        <NumericTextInput2
          name="employmentMoving"
          caption="引越し費用"
          v-model="requestPost.employmentMoving"
          :disabled="referenceMode"
          :required="isRequired('引越し費用')"
          :error="!requireValidateStr('employmentMoving', '引越し費用').result"
          :errorMessage="requireValidateStr('employmentMoving', '引越し費用').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('駐車場（法人契約）')">
        <SelectionButton2
          name="employmentParkingCorporation"
          caption="駐車場（法人契約）"
          v-model="requestPost.employmentParkingCorporation"
          :item="yesNo"
          :multiSelect="false"
          :disabled="referenceMode"
          :required="isRequired('駐車場（法人契約）')"
          :error="!requireValidateArr('employmentParkingCorporation', '駐車場（法人契約）').result"
          :errorMessage="requireValidateArr('employmentParkingCorporation', '駐車場（法人契約）').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('駐車場（個人契約）')">
        <SelectionButton2
          name="employmentParkingPrivate"
          caption="駐車場（個人契約）"
          v-model="requestPost.employmentParkingPrivate"
          :item="yesNo"
          :multiSelect="false"
          :disabled="referenceMode"
          :required="isRequired('駐車場（個人契約）')"
          :error="!requireValidateArr('employmentParkingPrivate', '駐車場（個人契約）').result"
          :errorMessage="requireValidateArr('employmentParkingPrivate', '駐車場（個人契約）').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('駐車場費用')">
        <NumericTextInput2
          name="employmentCostPrivate"
          caption="駐車場費用"
          v-model="requestPost.employmentCostPrivate"
          :disabled="referenceMode"
          :required="isRequired('駐車場費用')"
          :error="!requireValidateStr('employmentCostPrivate', '駐車場費用').result"
          :errorMessage="requireValidateStr('employmentCostPrivate', '駐車場費用').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('メールアドレス')">
        <div class="flex" v-if="!referenceMode">
          <WmsTextInput
            name="employmentMail"
            caption="メールアドレス"
            v-model="requestPost.employmentMail"
            :required="isRequired('メールアドレス')"
            :error="!requireValidateStr('employmentMail', 'メールアドレス').result"
            :errorMessage="requireValidateStr('employmentMail', 'メールアドレス').message"
          />
          <WmsSuggestInput
            name="employmentMailDomain"
            :selectionItems="domainList"
            displayField="val"
            class="mt-auto"
            v-model="requestPost.employmentMailDomain"
          >
          </WmsSuggestInput>
        </div>
        <div v-else>
          <div class="block text-xs font-bold text-gray-700 relative mb-1">メールアドレス<span v-if="isRequired('メールアドレス')" class="absolute -top-0.5 ml-1 text-red-500"> * </span></div>
          <div class="rounded border border-gray-300 bg-gray-200 py-2 px-3 text-sm text-gray-700">
            {{ requestPost.employmentMail + requestPost.employmentMailDomain }}
          </div>
        </div>
      </div>

      <div class="sm:col-span-full" v-if="isShow('退職日（有給消化後）')">
        <WmsDateInput
          name="employmentRetirementDate"
          caption="退職日（有給消化後）"
          v-model="requestPost.employmentRetirementDate"
          :clearable="false"
          :required="isRequired('退職日（有給消化後）')"
          :error="!requireValidateStr('employmentRetirementDate', '退職日（有給消化後）').result"
          :errorMessage="requireValidateStr('employmentRetirementDate', '退職日（有給消化後）').message"
          @change="setLimitDate()"
          :disabled="referenceMode"
        />

        <div class="mt-3 text-gray-600 text-xs fonty-bold mb-1">※最終勤務日が過ぎるとユーザー削除されるのでログインできません</div>
        <WmsDateInput
          name="employmentWorkEndDate"
          caption="最終勤務日（有給消化に入る前の実際の最終就労日）"
          v-model="requestPost.employmentWorkEndDate"
          :max="requestPost.employmentRetirementDate"
          :clearable="false"
          :required="isRequired('最終勤務日')"
          :error="!requireValidateStr('employmentWorkEndDate', '最終勤務日').result"
          :errorMessage="requireValidateStr('employmentWorkEndDate', '最終勤務日').message"
          @change="setLimitDate()"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('駐車場契約状況')">
        <SelectionButton2
          name="employmentParkingStatus"
          caption="駐車場契約状況"
          v-model="requestPost.employmentParkingStatus"
          :item="yesNo"
          :multiSelect="false"
          :disabled="referenceMode"
          :required="isRequired('駐車場契約状況')"
          :error="!requireValidateArr('employmentParkingStatus', '駐車場契約状況').result"
          :errorMessage="requireValidateArr('employmentParkingStatus', '駐車場契約状況').message"
        />
      </div>

      <div class="sm:col-span-full" v-if="isShow('契約方法')">
        <SelectionButton2
          name="employmentContract"
          caption="契約方法"
          v-model="requestPost.employmentContract"
          :item="constractItems"
          :multiSelect="false"
          :disabled="referenceMode"
          :required="isRequired('契約方法')"
          :error="!requireValidateArr('employmentContract', '契約方法').result"
          :errorMessage="requireValidateArr('employmentContract', '契約方法').message"
        />
      </div>

      <!-- ここまで社員の項目 -end- -->

      <div class="sm:col-span-full" v-if="!isOther">
        <WmsTextInput
          name="employmentRemarks"
          caption="連絡事項"
          v-model="requestPost.employmentRemarks"
          :multiline="true"
          :rows="5"
          :disabled="referenceMode"
        />
      </div>
    </div>

    <!-- 契約物件情報 -->
    <div v-if="requestPost.employmentClass.includes('契約変更')&&requestPost.changeData&&requestPost.changeData.length" class="mt-5 text-xs font-bold text-gray-700 mb-1">変更箇所あり</div>
    <div v-if="requestPost.employmentClass.includes('契約変更')&&requestPost.changeData&&requestPost.changeData.length" class="rounded border border-gray-800 p-2 bg-yellow-50 flex flex-wrap">
      <div v-for="(key, i) in requestPost.changeData" :key="'ch'+i" class="text-sm text-gray-700 my-2 mx-3">
        <div>
          <div class="mb-2 font-bold">{{ key.site }}</div>
          <div v-for="(row, j) in key.list" :key="'chrow'+j" class="my-1">
            ● {{ row }}
          </div>
        </div>
      </div>
    </div>

    <div class="sm:col-span-full mt-3" v-if="requestPost.employmentClass.includes('契約変更')">
      <div v-for="(contract, index) in requestPost.contractList" v-bind:key="contract.cdSite + index">
        <InputGroupLabel
          name="categoryTitle"
          :caption="'契約物件（' + (index + 1) + '）'"
          class="mb-3"
        />

        <div class="flex w-full text-blue-700 font-bold">
          <div class="text-xs font-bold text-gray-700 w-14 self-center">物件名：</div>
          <div>{{ contract.nameSite }}</div>
          <div class="text-xs font-bold text-gray-700 self-center ml-6">物件コード：</div>
          <div>{{ contract.cdSite }}</div>
          <div class="text-xs font-bold text-gray-700 self-center ml-4">契約：</div>
          <div>{{ contract.cdContract }}</div>
        </div>

        <div class="flex w-full text-blue-700 font-bold">
          <div class="text-xs font-bold text-gray-700 w-14 self-center">得意先：</div>
          <div>{{ contract.nameCustomer }}</div>
          <div v-if="contract.nameCustomer2" class="ml-2 font-normal text-sm self-center">（{{ contract.nameCustomer2 }}）</div>
        </div>

        <div class="sm:col-span-full grid grid-cols-20 my-3">
          <div class="sm:col-span-9">
            <div class="contract-frame">
              <div class="text-xs text-gray-700 font-bold">月曜 出勤形態</div>
              <select
                class="w-full rounded border-gray-300 text-sm bg-gray-200 cursor-not-allowed text-gray-800"
                v-model="contract.attendanceMonday"
                :disabled="true"
              >
                <option v-for="(row, index) in attendanceTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="月曜 実働時間"
                v-model="contract.workingHoursMonday"
                :decimalPlace="getDecimalPlace(contract.workingHoursMonday)"
                :disabled="true"
              />
              <div class="flex" v-if="!referenceMode">
                <div class="">
                  <WmsTimeInput2
                    name="startMonday"
                    caption="月曜 勤務時間"
                    v-model="contract.startMonday"
                    class="time"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTimeInput2
                    name="endMonday"
                    caption=""
                    v-model="contract.endMonday"
                    class="time"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="true"
                  />
                </div>
              </div>
              <div class="flex" v-else>
                <div class="">
                  <WmsTextInput
                    caption="月曜 勤務時間"
                    v-model="contract.startMonday"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTextInput
                    caption=""
                    v-model="contract.endMonday"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">火曜 出勤形態</div>
              <select
                class="w-full rounded border-gray-300 text-sm bg-gray-200 cursor-not-allowed text-gray-800"
                v-model="contract.attendanceTuesday"
                :disabled="true"
              >
                <option v-for="(row, index) in attendanceTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="火曜 実働時間"
                v-model="contract.workingHoursTuesday"
                :decimalPlace="getDecimalPlace(contract.workingHoursTuesday)"
                :disabled="true"
              />
              <div class="flex" v-if="!referenceMode">
                <div class="">
                  <WmsTimeInput2
                    name="startTuesday"
                    caption="火曜 勤務時間"
                    v-model="contract.startTuesday"
                    class="time"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTimeInput2
                    name="endTuesday"
                    caption=""
                    v-model="contract.endTuesday"
                    class="time"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="true"
                  />
                </div>
              </div>
              <div class="flex" v-else>
                <div class="">
                  <WmsTextInput
                    caption="火曜 勤務時間"
                    v-model="contract.startTuesday"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTextInput
                    caption=""
                    v-model="contract.endTuesday"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">水曜 出勤形態</div>
              <select
                class="w-full rounded border-gray-300 text-sm bg-gray-200 cursor-not-allowed text-gray-800"
                v-model="contract.attendanceWednesday"
                :disabled="true"
              >
                <option v-for="(row, index) in attendanceTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="水曜 実働時間"
                v-model="contract.workingHoursWednesday"
                :decimalPlace="getDecimalPlace(contract.workingHoursWednesday)"
                :disabled="true"
              />
              <div class="flex" v-if="!referenceMode">
                <div class="">
                  <WmsTimeInput2
                    name="startWednesday"
                    caption="水曜 勤務時間"
                    v-model="contract.startWednesday"
                    class="time"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTimeInput2
                    name="endWednesday"
                    caption=""
                    v-model="contract.endWednesday"
                    class="time"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="true"
                  />
                </div>
              </div>
              <div class="flex" v-else>
                <div class="">
                  <WmsTextInput
                    caption="水曜 勤務時間"
                    v-model="contract.startWednesday"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTextInput
                    caption=""
                    v-model="contract.endWednesday"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">木曜 出勤形態</div>
              <select
                class="w-full rounded border-gray-300 text-sm bg-gray-200 cursor-not-allowed text-gray-800"
                v-model="contract.attendanceThursday"
                :disabled="true"
              >
                <option v-for="(row, index) in attendanceTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="木曜 実働時間"
                v-model="contract.workingHoursThursday"
                :decimalPlace="getDecimalPlace(contract.workingHoursThursday)"
                :disabled="true"
              />
              <div class="flex" v-if="!referenceMode">
                <div class="">
                  <WmsTimeInput2
                    name="startThursday"
                    caption="木曜 勤務時間"
                    v-model="contract.startThursday"
                    class="time"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTimeInput2
                    name="endThursday"
                    caption=""
                    v-model="contract.endThursday"
                    class="time"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="true"
                  />
                </div>
              </div>
              <div class="flex" v-else>
                <div class="">
                  <WmsTextInput
                    caption="木曜 勤務時間"
                    v-model="contract.startThursday"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTextInput
                    caption=""
                    v-model="contract.endThursday"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">金曜 出勤形態</div>
              <select
                class="w-full rounded border-gray-300 text-sm bg-gray-200 cursor-not-allowed text-gray-800"
                v-model="contract.attendanceFriday"
                :disabled="true"
              >
                <option v-for="(row, index) in attendanceTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="金曜 実働時間"
                v-model="contract.workingHoursFriday"
                :decimalPlace="getDecimalPlace(contract.workingHoursFriday)"
                :disabled="true"
              />
              <div class="flex" v-if="!referenceMode">
                <div class="">
                  <WmsTimeInput2
                    name="startFriday"
                    caption="金曜 勤務時間"
                    v-model="contract.startFriday"
                    class="time"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTimeInput2
                    name="endFriday"
                    caption=""
                    v-model="contract.endFriday"
                    class="time"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="true"
                  />
                </div>
              </div>
              <div class="flex" v-else>
                <div class="">
                  <WmsTextInput
                    caption="金曜 勤務時間"
                    v-model="contract.startFriday"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTextInput
                    caption=""
                    v-model="contract.endFriday"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">土曜 出勤形態</div>
              <select
                class="w-full rounded border-gray-300 text-sm bg-gray-200 cursor-not-allowed text-gray-800"
                v-model="contract.attendanceSaturday"
                :disabled="true"
              >
                <option v-for="(row, index) in attendanceTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="土曜 実働時間"
                v-model="contract.workingHoursSaturday"
                :decimalPlace="getDecimalPlace(contract.workingHoursSaturday)"
                :disabled="true"
              />
              <div class="flex" v-if="!referenceMode">
                <div class="">
                  <WmsTimeInput2
                    name="startSaturday"
                    caption="土曜 勤務時間"
                    v-model="contract.startSaturday"
                    class="time"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTimeInput2
                    name="endSaturday"
                    caption=""
                    v-model="contract.endSaturday"
                    class="time"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="true"
                  />
                </div>
              </div>
              <div class="flex" v-else>
                <div class="">
                  <WmsTextInput
                    caption="土曜 勤務時間"
                    v-model="contract.startSaturday"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTextInput
                    caption=""
                    v-model="contract.endSaturday"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">日曜 出勤形態</div>
              <select
                class="w-full rounded border-gray-300 text-sm bg-gray-200 cursor-not-allowed text-gray-500"
                v-model="contract.attendanceSunday"
                :disabled="true"
              >
                <option v-for="(row, index) in attendanceTypes" :value="row.value" :key="index">
                  {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="日曜 実働時間"
                v-model="contract.workingHoursSunday"
                :decimalPlace="getDecimalPlace(contract.workingHoursSunday)"
                :disabled="true"
              />
              <div class="flex" v-if="!referenceMode">
                <div class="">
                  <WmsTimeInput2
                    name="startSunday"
                    caption="日曜 勤務時間"
                    v-model="contract.startSunday"
                    class="time"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTimeInput2
                    name="endSunday"
                    caption=""
                    v-model="contract.endSunday"
                    class="time"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="true"
                  />
                </div>
              </div>
              <div class="flex" v-else>
                <div class="">
                  <WmsTextInput
                    caption="日曜 勤務時間"
                    v-model="contract.startSunday"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTextInput
                    caption=""
                    v-model="contract.endSunday"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">


              <div class="text-xs text-gray-700 font-bold">賃金 区分</div>
              <select
                class="w-full rounded border-gray-300 text-sm bg-gray-200 cursor-not-allowed text-gray-800"
                v-model="contract.kubunWage"
                :disabled="true"
              >
                <option v-for="(row, index) in wageTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="賃金"
                v-model="contract.basicWage"
                :disabled="true"
              />

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">電車 区分</div>
              <select
                class="w-full rounded border-gray-300 text-sm bg-gray-200 cursor-not-allowed text-gray-800"
                v-model="contract.kubunTrain"
                :disabled="true"
              >
                <option v-for="(row, index) in provisionSelections2" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="電車 金額"
                v-model="contract.fareTrain"
                :disabled="true"
              />

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">バス 区分</div>
              <select
                class="w-full rounded border-gray-300 text-sm bg-gray-200 cursor-not-allowed text-gray-800"
                v-model="contract.kubunBus"
                :disabled="true"
              >
                <option v-for="(row, index) in provisionSelections2" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="バス 金額"
                v-model="contract.fareBus"
                :disabled="true"
              />

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">駐輪 区分</div>
              <select
                class="w-full rounded border-gray-300 text-sm bg-gray-200 cursor-not-allowed text-gray-800"
                v-model="contract.kubunBicycleParking"
                :disabled="true"
              >
                <option v-for="(row, index) in provisionSelections2" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="駐輪 金額"
                v-model="contract.fareBicycleParking"
                :disabled="true"
              />
            </div>
          </div>

          <div class="sm:col-span-2 contract-arrow">
            ⇒
          </div>

          <div class="sm:col-span-9">
            <div class="contract-frame">
              <div class="text-xs text-gray-700 font-bold">月曜 出勤形態</div>
              <select
                class="w-full rounded border-gray-300 text-sm"
                v-model="contract.iAttendanceMonday"
                :disabled="referenceMode"
                :class="[referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':'', getBgColor(contract, 'attendanceMonday')]"
                @change="changeContractChangeItem(contract, 'attendanceMonday', 'iAttendanceMonday')"
              >
                <option v-for="(row, index) in attendanceTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="月曜 実働時間"
                maxLenght="2"
                v-model="contract.iWorkingHoursMonday"
                :decimalPlace="getDecimalPlace(contract.iWorkingHoursMonday)"
                :class="getBgColor(contract, 'workingHoursMonday')"
                :disabled="referenceMode"
                @change="changeContractChangeItem(contract, 'workingHoursMonday', 'iWorkingHoursMonday')"
              />
              <div class="flex" v-if="!referenceMode">
                <div class="">
                  <WmsTimeInput2
                    name="iStartMonday"
                    caption="月曜 勤務時間"
                    v-model="contract.iStartMonday"
                    class="time"
                    :class="getBgColor(contract, 'startMonday')"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode"
                    @change="changeContractChangeItem(contract, 'startMonday', 'iStartMonday')"
                    />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTimeInput2
                    name="iEndMonday"
                    caption=""
                    v-model="contract.iEndMonday"
                    class="time"
                    :class="getBgColor(contract, 'endMonday')"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode"
                    @change="changeContractChangeItem(contract, 'endMonday', 'iEndMonday')"
                    />
                </div>
              </div>
              <div class="flex" v-else>
                <div class="">
                  <WmsTextInput
                    caption="月曜 勤務時間"
                    v-model="contract.iStartMonday"
                    :class="getBgColor(contract, 'startMonday')"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTextInput
                    caption=""
                    v-model="contract.iEndMonday"
                    :class="getBgColor(contract, 'endMonday')"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">火曜 出勤形態</div>
              <select
                class="w-full rounded border-gray-300 text-sm"
                v-model="contract.iAttendanceTuesday"
                :disabled="referenceMode"
                :class="[referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':'', getBgColor(contract, 'attendanceTuesday')]"
                @change="changeContractChangeItem(contract, 'attendanceTuesday', 'iAttendanceTuesday')"
              >
                <option v-for="(row, index) in attendanceTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="火曜 実働時間"
                maxLenght="2"
                v-model="contract.iWorkingHoursTuesday"
                :decimalPlace="getDecimalPlace(contract.iWorkingHoursTuesday)"
                :class="getBgColor(contract, 'workingHoursTuesday')"
                :disabled="referenceMode"
                @change="changeContractChangeItem(contract, 'workingHoursTuesday', 'iWorkingHoursTuesday')"
              />
              <div class="flex" v-if="!referenceMode">
                <div class="">
                  <WmsTimeInput2
                    name="iStartTuesday"
                    caption="火曜 勤務時間"
                    v-model="contract.iStartTuesday"
                    class="time"
                    :class="getBgColor(contract, 'startTuesday')"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode"
                    @change="changeContractChangeItem(contract, 'startTuesday', 'iStartTuesday')"
                    />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTimeInput2
                    name="iEndTuesday"
                    caption=""
                    v-model="contract.iEndTuesday"
                    class="time"
                    :class="getBgColor(contract, 'endTuesday')"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode"
                    @change="changeContractChangeItem(contract, 'endTuesday', 'iEndTuesday')"
                    />
                </div>
              </div>
              <div class="flex" v-else>
                <div class="">
                  <WmsTextInput
                    caption="火曜 勤務時間"
                    v-model="contract.iStartTuesday"
                    :class="getBgColor(contract, 'startTuesday')"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTextInput
                    caption=""
                    v-model="contract.iEndTuesday"
                    :class="getBgColor(contract, 'endTuesday')"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">水曜 出勤形態</div>
              <select
                class="w-full rounded border-gray-300 text-sm"
                v-model="contract.iAttendanceWednesday"
                :disabled="referenceMode"
                :class="[referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':'', getBgColor(contract, 'attendanceWednesday')]"
                @change="changeContractChangeItem(contract, 'attendanceWednesday', 'iAttendanceWednesday')"
              >
                <option v-for="(row, index) in attendanceTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="水曜 実働時間"
                maxLenght="2"
                v-model="contract.iWorkingHoursWednesday"
                :decimalPlace="getDecimalPlace(contract.iWorkingHoursWednesday)"
                :class="getBgColor(contract, 'workingHoursWednesday')"
                :disabled="referenceMode"
                @change="changeContractChangeItem(contract, 'workingHoursWednesday', 'iWorkingHoursWednesday')"
              />
              <div class="flex" v-if="!referenceMode">
                <div class="">
                  <WmsTimeInput2
                    name="iStartWednesday"
                    caption="水曜 勤務時間"
                    v-model="contract.iStartWednesday"
                    class="time"
                    :class="getBgColor(contract, 'startWednesday')"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode"
                    @change="changeContractChangeItem(contract, 'startWednesday', 'iStartWednesday')"
                    />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTimeInput2
                    name="iEndWednesday"
                    caption=""
                    v-model="contract.iEndWednesday"
                    class="time"
                    :class="getBgColor(contract, 'endWednesday')"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode"
                    @change="changeContractChangeItem(contract, 'endWednesday', 'iEndWednesday')"
                    />
                </div>
              </div>
              <div class="flex" v-else>
                <div class="">
                  <WmsTextInput
                    caption="水曜 勤務時間"
                    v-model="contract.iStartWednesday"
                    :class="getBgColor(contract, 'startWednesday')"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTextInput
                    caption=""
                    v-model="contract.iEndWednesday"
                    :class="getBgColor(contract, 'endWednesday')"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">木曜 出勤形態</div>
              <select
                class="w-full rounded border-gray-300 text-sm"
                v-model="contract.iAttendanceThursday"
                :disabled="referenceMode"
                :class="[referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':'', getBgColor(contract, 'attendanceThursday')]"
                @change="changeContractChangeItem(contract, 'attendanceThursday', 'iAttendanceThursday')"
              >
                <option v-for="(row, index) in attendanceTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="木曜 実働時間"
                maxLenght="2"
                v-model="contract.iWorkingHoursThursday"
                :decimalPlace="getDecimalPlace(contract.iWorkingHoursThursday)"
                :class="getBgColor(contract, 'workingHoursThursday')"
                :disabled="referenceMode"
                @change="changeContractChangeItem(contract, 'workingHoursThursday', 'iWorkingHoursThursday')"
              />
              <div class="flex" v-if="!referenceMode">
                <div class="">
                  <WmsTimeInput2
                    name="iStartThursday"
                    caption="木曜 勤務時間"
                    v-model="contract.iStartThursday"
                    class="time"
                    :class="getBgColor(contract, 'startThursday')"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode"
                    @change="changeContractChangeItem(contract, 'startThursday', 'iStartThursday')"
                    />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTimeInput2
                    name="iEndThursday"
                    caption=""
                    v-model="contract.iEndThursday"
                    class="time"
                    :class="getBgColor(contract, 'endThursday')"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode"
                    @change="changeContractChangeItem(contract, 'endThursday', 'iEndThursday')"
                    />
                </div>
              </div>
              <div class="flex" v-else>
                <div class="">
                  <WmsTextInput
                    caption="木曜 勤務時間"
                    v-model="contract.iStartThursday"
                    :class="getBgColor(contract, 'startThursday')"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTextInput
                    caption=""
                    v-model="contract.iEndThursday"
                    :class="getBgColor(contract, 'endThursday')"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">金曜 出勤形態</div>
              <select
                class="w-full rounded border-gray-300 text-sm"
                v-model="contract.iAttendanceFriday"
                :disabled="referenceMode"
                :class="[referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':'', getBgColor(contract, 'attendanceFriday')]"
                @change="changeContractChangeItem(contract, 'attendanceFriday', 'iAttendanceFriday')"
              >
                <option v-for="(row, index) in attendanceTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="金曜 実働時間"
                maxLenght="2"
                v-model="contract.iWorkingHoursFriday"
                :decimalPlace="getDecimalPlace(contract.iWorkingHoursFriday)"
                :class="getBgColor(contract, 'workingHoursFriday')"
                :disabled="referenceMode"
                @change="changeContractChangeItem(contract, 'workingHoursFriday', 'iWorkingHoursFriday')"
              />
              <div class="flex" v-if="!referenceMode">
                <div class="">
                  <WmsTimeInput2
                    name="iStartFriday"
                    caption="金曜 勤務時間"
                    v-model="contract.iStartFriday"
                    class="time"
                    :class="getBgColor(contract, 'startFriday')"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode"
                    @change="changeContractChangeItem(contract, 'startFriday', 'iStartFriday')"
                    />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTimeInput2
                    name="iEndFriday"
                    caption=""
                    v-model="contract.iEndFriday"
                    class="time"
                    :class="getBgColor(contract, 'endFriday')"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode"
                    @change="changeContractChangeItem(contract, 'endFriday', 'iEndFriday')"
                    />
                </div>
              </div>
              <div class="flex" v-else>
                <div class="">
                  <WmsTextInput
                    caption="金曜 勤務時間"
                    v-model="contract.iStartFriday"
                    :class="getBgColor(contract, 'startFriday')"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTextInput
                    caption=""
                    v-model="contract.iEndFriday"
                    :class="getBgColor(contract, 'endFriday')"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">土曜 出勤形態</div>
              <select
                class="w-full rounded border-gray-300 text-sm"
                v-model="contract.iAttendanceSaturday"
                :disabled="referenceMode"
                :class="[referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':'', getBgColor(contract, 'attendanceSaturday')]"
                @change="changeContractChangeItem(contract, 'attendanceSaturday', 'iAttendanceSaturday')"
              >
                <option v-for="(row, index) in attendanceTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="土曜 実働時間"
                maxLenght="2"
                v-model="contract.iWorkingHoursSaturday"
                :decimalPlace="getDecimalPlace(contract.iWorkingHoursSaturday)"
                :class="getBgColor(contract, 'workingHoursSaturday')"
                :disabled="referenceMode"
                @change="changeContractChangeItem(contract, 'workingHoursSaturday', 'iWorkingHoursSaturday')"
              />
              <div class="flex" v-if="!referenceMode">
                <div class="">
                  <WmsTimeInput2
                    name="iStartSaturday"
                    caption="土曜 勤務時間"
                    v-model="contract.iStartSaturday"
                    class="time"
                    :class="getBgColor(contract, 'startSaturday')"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode"
                    @change="changeContractChangeItem(contract, 'startSaturday', 'iStartSaturday')"
                    />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTimeInput2
                    name="iEndSaturday"
                    caption=""
                    v-model="contract.iEndSaturday"
                    class="time"
                    :class="getBgColor(contract, 'endSaturday')"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode"
                    @change="changeContractChangeItem(contract, 'endSaturday', 'iEndSaturday')"
                    />
                </div>
              </div>
              <div class="flex" v-else>
                <div class="">
                  <WmsTextInput
                    caption="土曜 勤務時間"
                    v-model="contract.iStartSaturday"
                    :class="getBgColor(contract, 'startSaturday')"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTextInput
                    caption=""
                    v-model="contract.iEndSaturday"
                    :class="getBgColor(contract, 'endSaturday')"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">
              <div class="text-xs text-gray-700 font-bold">日曜 出勤形態</div>
              <select
                class="w-full rounded border-gray-300 text-sm"
                v-model="contract.iAttendanceSunday"
                :disabled="referenceMode"
                :class="[referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':'', getBgColor(contract, 'attendanceSunday')]"
                @change="changeContractChangeItem(contract, 'attendanceSunday', 'iAttendanceSunday')"
              >
                <option v-for="(row, index) in attendanceTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="日曜 実働時間"
                maxLenght="2"
                v-model="contract.iWorkingHoursSunday"
                :decimalPlace="getDecimalPlace(contract.iWorkingHoursSunday)"
                :class="getBgColor(contract, 'workingHoursSunday')"
                :disabled="referenceMode"
                @change="changeContractChangeItem(contract, 'workingHoursSunday', 'iWorkingHoursSunday')"
              />

              <div class="flex" v-if="!referenceMode">
                <div class="">
                  <WmsTimeInput2
                    name="iStartSunday"
                    caption="日曜 勤務時間"
                    v-model="contract.iStartSunday"
                    class="time"
                    :class="getBgColor(contract, 'startSunday')"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode"
                    @change="changeContractChangeItem(contract, 'startSunday', 'iStartSunday')"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTimeInput2
                    name="iEndSunday"
                    caption=""
                    v-model="contract.iEndSunday"
                    class="time"
                    :class="getBgColor(contract, 'endSunday')"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode"
                    @change="changeContractChangeItem(contract, 'endSunday', 'iEndSunday')"
                  />
                </div>
              </div>
              <div class="flex" v-else>
                <div class="">
                  <WmsTextInput
                    caption="日曜 勤務時間"
                    v-model="contract.iStartSunday"
                    :class="getBgColor(contract, 'startSunday')"
                    :disabled="true"
                  />
                </div>
                <div class="mt-6 mx-1 font-bold">～</div>
                <div class="mt-4">
                  <WmsTextInput
                    caption=""
                    v-model="contract.iEndSunday"
                    :class="getBgColor(contract, 'endSunday')"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">賃金 区分</div>
              <select
                class="w-full rounded border-gray-300 text-sm"
                v-model="contract.iKubunWage"
                required="true"
                :disabled="referenceMode"
                :class="[referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':'', getBgColor(contract, 'kubunWage')]"
                @change="changeContractChangeItem(contract, 'kubunWage', 'iKubunWage')"
              >
                <option v-for="(row, index) in wageTypes" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="賃金"
                v-model="contract.iBasicWage"
                :class="getBgColor(contract, 'basicWage')"
                :disabled="referenceMode"
                @change="changeContractChangeItem(contract, 'basicWage', 'iBasicWage')"
              />

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">電車 区分</div>
              <select
                class="w-full rounded border-gray-300 text-sm"
                v-model="contract.iKubunTrain"
                :disabled="referenceMode"
                :class="[referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':'', getBgColor(contract, 'kubunTrain')]"
                @change="changeFareKubun(contract, 'kubunTrain', 'iKubunTrain', 'iFareTrain')"
              >
                <option v-for="(row, index) in provisionSelections2" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="電車 金額"
                v-model="contract.iFareTrain"
                :class="getBgColor(contract, 'fareTrain')"
                :disabled="referenceMode"
                @change="changeContractChangeItem(contract, 'fareTrain', 'iFareTrain')"
              />

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">バス 区分</div>
              <select
                class="w-full rounded border-gray-300 text-sm"
                v-model="contract.iKubunBus"
                :disabled="referenceMode"
                :class="[referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':'', getBgColor(contract, 'kubunBus')]"
                @change="changeFareKubun(contract, 'kubunBus', 'iKubunBus', 'iFareBus')"
              >
                <option v-for="(row, index) in provisionSelections2" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="バス 金額"
                v-model="contract.iFareBus"
                :class="getBgColor(contract, 'fareBus')"
                :disabled="referenceMode"
                @change="changeContractChangeItem(contract, 'fareBus', 'iFareBus')"
              />

              <hr class="hr-week">

              <div class="text-xs text-gray-700 font-bold">駐輪 区分</div>
              <select
                class="w-full rounded border-gray-300 text-sm"
                v-model="contract.iKubunBicycleParking"
                :disabled="referenceMode"
                :class="[referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':'', getBgColor(contract, 'kubunBicycleParking')]"
                @change="changeFareKubun(contract, 'kubunBicycleParking', 'iKubunBicycleParking', 'iFareBicycleParking')"
              >
                <option v-for="(row, index) in provisionSelections2" :value="row.value" :key="index">
                    {{ row.text }}
                </option>
              </select>
              <NumericTextInput2
                caption="駐輪 金額"
                v-model="contract.iFareBicycleParking"
                :class="getBgColor(contract, 'fareBicycleParking')"
                :disabled="referenceMode"
                @change="changeContractChangeItem(contract, 'fareBicycleParking', 'iFareBicycleParking')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 物件選択モーダル -->
    <SiteSelectorModal
      v-model="siteModal"
      :open="siteModal"
      @modalSiteSelected="siteSelected"
    />

    <!-- 得意先検索モーダル -->
    <ClientSelectorModal
      v-model="clientModal"
      :open="clientModal"
      @modalClientSelected="modalClientSelected"
    />

    <!-- 得意先へ連絡モーダル -->
    <MessageForClientModal
      v-model="messageForClient"
      :open="messageForClient"
      :isMail="isMail"
      :clientFax="requestPost.clientFax"
      :clientName="requestPost.employmentCustomer"
      :client="client"
      :requestPost="requestPost"
      @close="messageForClient=false"
    />

    <!-- 退社専用Chatwork設定 -->
    <InterviewsChatRoomIdModal
      v-model="openChatRoomId"
      :open="openChatRoomId"
      :type="2"
      @close="openChatRoomId=false"
    />

    <!-- 社員の名札（ユーザーマスタから選ぶ） -->
    <EmployeeNameplateModal
      v-model="nameplateShow"
      :open="nameplateOpen"
    />
  </div>
</template>

<script>
  import * as utils from '@libs/utils'
  import * as dialogs from '@libs/dialogs'
  import * as helper from '@libs/helper'
  import * as constants from '@libs/constants'
  import * as backend from '@libs/backend'
  import moment from 'moment'
  import Icon from '@components/Icon.vue'
  import InputIcon from '@components/InputIcon.vue'
  import PrimaryButton from '@components/PrimaryButton.vue'
  import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
  import WmsTextInput from '@wmscomponents/WmsTextInput.vue'
  import WmsTimeInput2 from '@wmscomponents/WmsTimeInput2.vue'
  import NumericTextInput2 from '@components/NumericTextInput2.vue'
  import SelectionButton2 from '@components/SelectionButton2.vue'
  import WmsAttachment from '@wmscomponents/WmsAttachment.vue'
  import InputGroupLabel from '../components/InputGroupLabel.vue'
  import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
  import SiteSelectorModal from '../components/SiteSelectorModal.vue'
  import ClientSelectorModal from '../components/ClientSelectorModal.vue'
  import MessageForClientModal from '../components/MessageForClientModal.vue'
  import InterviewsChatRoomIdModal from '../components/InterviewsChatRoomIdModal.vue'
  import EmployeeNameplateModal from '../../User/components/EmployeeNameplateModal.vue'

  const SEX_SELECTIONS = [
    {
      value: '男性',
      text: '男性'
    },
    {
      value: '女性',
      text: '女性'
    }
  ]

  const CLASS_SELECTIONS = [
  {
      value: '物件追加',
      text: '物件追加'
    },
    {
      value: '契約変更',
      text: '契約変更'
    },
    {
      value: '退職',
      text: '退職'
    },
    {
      value: 'その他変更',
      text: 'その他変更'
    },
    {
      value: '新規入社',
      text: '新規入社'
    },
    {
      value: '再入社',
      text: '再入社'
    }
  ]

  const CLASS_SELECTIONS2 = [
    {
      value: '社員入社',
      text: '社員入社'
    },
    {
      value: '社員退職',
      text: '社員退職'
    }
  ]

  const CLOSINGDATE_SELECTIONS = [
    {
      value: '20日',
      text: '20日'
    },
    {
      value: '30日',
      text: '30日'
    }
  ]

  const CONSTRACT_SELECTIONS = [
    {
      value: '法人契約',
      text: '法人契約'
    },
    {
      value: '個人契約',
      text: '個人契約'
    }
  ]

  const HOURS =  [
    { text: '4' },
    { text: '5' },
    { text: '6' },
    { text: '7' },
    { text: '8' },
    { text: '9' },
    { text: '10' },
    { text: '11' },
    { text: '12' },
    { text: '13' },
    { text: '14' },
    { text: '15' },
    { text: '16' },
    { text: '17' },
    { text: '18' },
    { text: '19' },
    { text: '20' },
    { text: '21' },
    { text: '22' },
    { text: '23' }
  ]

  const MINUTES = [
    { text: '00' },
    { text: '10' },
    { text: '15' },
    { text: '20' },
    { text: '25' },
    { text: '30' },
    { text: '35' },
    { text: '40' },
    { text: '45' },
    { text: '50' },
    { text: '55' }
  ]

  // 新規入社 必須項目
  const ENTER = ['入社日', '氏名', 'フリガナ', '生年月日', '年齢', '性別', '郵便番号', '住所１', '携帯電話', '物件名', 'エリア', '得意先名', '作業内容', '時給', 'ご応募いただいた勤務曜日', '勤務時間', '祝日区分', 'ゴミ搬出', '必要な書類', '履歴書']
  // 再入社 必須項目
  const AGAIN = ['入社日', '氏名', '携帯電話', '物件名', 'エリア', '得意先名', '作業内容', '時給', '交通費', '電車 区分', '電車 交通費', 'バス 区分', 'バス 交通費', '駐輪 区分', '駐輪 交通費', 'ご応募いただいた勤務曜日', '勤務時間',  '祝日区分', 'ゴミ搬出', '必要な書類']
  // 再入社 必須ではないが表示する
  const AGAIN_NOT_REQUIRE = ['緊急連絡先']
  // 物件追加 必須項目
  const ADD = ['入社日', '氏名', '物件名', 'エリア', '得意先名', '作業内容', '時給', '交通費', '電車 区分', '電車 交通費', 'バス 区分', 'バス 交通費', '駐輪 区分', '駐輪 交通費', 'ご応募いただいた勤務曜日', '勤務時間',  '祝日区分', 'ゴミ搬出', '必要な書類']
  // 契約変更 必須項目
  const RETIRE1 = ['変更もしくは終了', '変更日 ', '氏名', '物件名', 'エリア', '得意先名']
  // 退職 必須項目
  const RETIRE2 = ['退職日', '氏名']
  // 退職 必須ではないが表示する
  const RETIRE2_NOT_REQUIRE = ['物件名', 'エリア', '得意先名']
  // その他変更 必須
  const OTHER = ['氏名', '物件名', '変更日']

  // 社員入社 必須項目
  const ENTER_PER = ['入社日', '氏名', 'フリガナ', '部署', '同行者', '週休●日制', '公休日', '引越し費用', '駐車場（法人契約）', '駐車場（個人契約）', 'メールアドレス']
  // 社員退職 必須項目
  const RETIRE_PER = ['退職日（有給消化後）', '最終勤務日', '氏名', 'フリガナ', '駐車場契約状況']


  export default {
    components: {
      Icon,
      InputIcon,
      PrimaryButton,
      WmsDateInput,
      WmsTextInput,
      WmsTimeInput2,
      NumericTextInput2,
      InputGroupLabel,
      SelectionButton2,
      WmsAttachment,
      WmsSuggestInput,
      SiteSelectorModal,
      ClientSelectorModal,
      MessageForClientModal,
      InterviewsChatRoomIdModal,
      EmployeeNameplateModal
    },

    props: {
      requestPost: {
        type: Object,
        default: () => {}
      },
      isDisabled: {
        type: Boolean,
        default: false
      },
      isTaskRequestMode: {
        type: Boolean,
        default: false
      },
      referenceMode: {
        type: Boolean,
        default: false
      },
      clientLists: {
        type: Array
      },
      departmentLists: {
        type: Array
      }
    },

    data() {
      return {
        sexSelections: SEX_SELECTIONS,
        // classSelections: CLASS_SELECTIONS,
        areaSelections: constants.AREA_SELECTIONS,
        provisionSelections: constants.PROVISION_SELECTIONS,
        provisionSelections2: constants.PROVISION_SELECTIONS2,
        workSelections: constants.WORK_SELECTIONS,
        holidayType: constants.HOLIDAYTYPE_SELECTIONS,
        yesNo: constants.YES_NO_SELECTIONS,
        closingDate: CLOSINGDATE_SELECTIONS,
        daysSelection: constants.DAYS_SELECTIONS,
        materialSelections: constants.MATERIAL_SELECTIONS,
        hourItems: HOURS,
        minuteItems: MINUTES,
        constractItems: CONSTRACT_SELECTIONS,
        weeklyHolidayItems: constants.WEEKLY_HOLIDAYS,
        attendanceTypes: constants.ATTENDANCE_TYPES,
        wageTypes: constants.WAGE_SELECTIONS2,
        domainList: constants.DOMAIN_SELECTIONS,
        // 清掃員リスト
        employmentNameList: [],
        // 物件リスト
        employmentBuildingList: [],
        // 物件リスト全取得
        allEmploymentBuildingList: [],
        // 物件検索モーダル
        siteModal: false,
        // 得意先検索モーダル
        clientModal: false,
        // 得意先へメール送信・FAXモーダル
        messageForClient: false,
        // 得意先へメール送信
        isMail: false,
        // 得意先情報
        client: {},
        // Chatwork設定モーダルopen
        openChatRoomId: false,
        // 社員の名札のモーダル
        nameplateShow: false,
        nameplateOpen: 0,
        reload: 0,
        loading: false
      }
    },

    computed: {
      /**
       * Chatwork設定できる人
       * 人事もしくは管理者権限
       */
      auth() {
        // 人事部所属
        const dep = this.$store.getters.dualPosition
        if (dep && dep.length) {
          // 人事部か確認
          const isDep = dep.find((d) => {
            return (d.departmentName.indexOf('人事') > -1)
          })
          if (isDep && isDep.departmentName) {
            return true
          }
        }
        // 管理者権限の場合
        let auth2 = this.$store.getters.auth
        if (auth2 && auth2.adminAuth) {
          return true
        }
        return false
      },

      /**
       * 種別の選択項目
       */
      classSelections() {
        let res = utils.clone(CLASS_SELECTIONS)
        // 社員の場合
        if (this.requestPost.employmentRegularStaff) {
          res = utils.clone(CLASS_SELECTIONS2)
        // 清掃員の場合
        } else {
          if (this.requestPost.notNewEnter) {
            res = CLASS_SELECTIONS.filter((c) => {
              return c.value != '新規入社'
            })
          }
        }
        return res
      },

      /**
       * 誕生日を和暦に変換
       */
      japaneseDate() {
        return (val)=> {
          if (val) {
            return utils.japaneseDate(val)
          } else {
            return ''
          }
        }
      },

      /**
       * 部署選択肢
       */
      departmentItems() {
        if (this.departmentLists && this.departmentLists.length) {
          return this.departmentLists.map((d) => {
            return { value: d.departmentId, text: d.name }
          })
        }
        return [{ value: '', text: '' }]
      },

      /**
       * ユーザーリスト
       */
      userList() {
        let res = []
        if (this.requestPost.employmentRegularStaff) {
          const list = this.$store.getters.userList
          if (list && list.length) {
            for (let i = 0; i < list.length; i++) {
              const l = list[i]
              if (l.user_name != '未定' && l.user_name.indexOf('管理') == -1 && !res.includes(l.user_name)) {
                res.push({ nameStaff: l.user_name, kana: l.user_kana, id: l.id })
              }
            }
          }
        }
        return res
      },

      /**
       * 必須項目入力チェック（文字列）
       */
      requireValidateStr() {
        return (item, name)=> {
          if (this.isRequired(name)) {
            if (!this.requestPost[item]) {

              if (name == '変更日 ' && this.requestPost.modifyType == 2) {
                name = '作業終了日'
              }

              return {
                result: false,
                message: `${name}は必須項目です。${name}を入力してください。`
              }
            }
          }

          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 必須項目入力チェック（配列）
       */
      requireValidateArr() {
        return (item, name)=> {
          if (this.isRequired(name)) {
            if (!this.requestPost[item] || !this.requestPost[item].length) {
              return {
                result: false,
                message: `${name}は必須項目です。${name}を選択してください。`
              }
            }
          }

          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 必須項目入力チェック（連想配列）
       */
      requireValidateArr2() {
        return (item, name)=> {
          if (this.isRequired(name)) {
            let input = '入力'
            if (Array.isArray(item)) {
              input = '選択'
            }
            if (!item || !item.length) {
              return {
                result: false,
                message: `${name}は必須項目です。${name}を${input}してください。`
              }
            }
            if (name == '勤務時間') {
              let time = item.split(':')
              if (!time[0]) {
                return {
                  result: false,
                  message: `${name}が不正です。${name}の入力値（時間の部分）を確認してください。`
                }
              }
              if (!time[1]) {
                return {
                  result: false,
                  message: `${name}が不正です。${name}の入力値（分の部分）を確認してください。`
                }
              }
            }
          }

          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 必須項目入力チェック（添付ファイル）
       */
      requireValidateAttach() {
        return (item, name)=> {
          if (this.isRequired(name)) {
            if (!this.requestPost[item] || (!this.requestPost[item].content && !this.requestPost[item].url)) {
              return {
                result: false,
                message: `${name}は必須項目です。${name}を添付してください。`
              }
            }
          }
          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 表示するか否か
       */
      isShow() {
        return (name) => {
          // 種別
          const ec = this.requestPost.employmentClass
          // 新規入社
          const enter = ['入社日', '氏名', 'フリガナ', '生年月日', '年齢', '性別', '郵便番号', '住所１', '住所２', '固定電話', '携帯電話', '緊急連絡先', '物件名', 'エリア', '得意先名', '作業内容', '時給', '締め日', '交通費', 'ご応募いただいた勤務曜日', '勤務時間', '祝日区分', 'ゴミ搬出', '必要な書類', '履歴書']
          // 「その他変更」の場合、表示する項目
          const other = ['氏名', '物件名', '変更日', '郵便番号', '住所１', '住所２', '固定電話', '携帯電話', '緊急連絡先', '交通費', '時給']
          // 「再入社」の場合、表示する項目
          const again = AGAIN.concat(AGAIN_NOT_REQUIRE)
          // 「退職」の場合、表示する項目
          const retired = RETIRE2.concat(RETIRE2_NOT_REQUIRE)

          // 社員入社 表示項目
          const enter_per = ['社員番号', '入社日', '氏名', 'フリガナ', '部署', '同行者', '週休●日制', '公休日', '引越し費用', '駐車場（法人契約）', '駐車場（個人契約）', '駐車場費用', 'メールアドレス']
          // 社員退職 表示項目
          const retire_per = ['社員番号', '退職日（有給消化後）', '氏名', 'フリガナ', '駐車場契約状況', '契約方法']

          if (ec && ec.length) {
            const e = ec[0]
            if (e == '新規入社') {
              if (enter.includes(name)) {
                return true
              }
            } else if (e == 'その他変更') {
              if (other.includes(name)) {
                return true
              }
            } else if (e == '再入社') {
              if (again.includes(name)) {
                return true
              }
            } else if (e == '退職') {
              if (retired.includes(name)) {
                return true
              }
            } else if (e == '社員入社') {
              if (enter_per.includes(name)) {
                return true
              }
            } else if (e == '社員退職') {
              if (retire_per.includes(name)) {
                return true
              }
            // その他は、必須項目になっているもののみ表示
            } else {
              return this.isRequired(name)
            }
          }
          return false
        }
      },

      /**
       * 「その他変更」を選択しているか
       */
      isOther() {
        if (this.requestPost.employmentClass && this.requestPost.employmentClass[0] == 'その他変更') {
          return true
        }
        return false
      },

      /**
       * 種別によって必須が変わる
       * @param name 項目名
       */
      isRequired() {
        return (name) => {
          // 種別はいつでも必須
          if (name == '種別') {
            return true
          }
          // 種別
          const ec = this.requestPost.employmentClass
          // 新規入社
          const enter = ENTER
          // 再入社
          const again = AGAIN
          // 物件追加
          const add = ADD
          // 契約変更
          const retire1 = RETIRE1
          // 退職
          const retire2 = RETIRE2
          // その他変更
          const other = OTHER
          // 社員入社
          const enterPer = ENTER_PER
          // 社員退職
          const retirePer = RETIRE_PER

          if (ec && ec.length) {
            const e = ec[0]
            if (e == '新規入社') {
              if (enter.includes(name)) {
                return true
              }
            } else if (e == '再入社') {
              if (again.includes(name)) {
                return true
              }
            } else if (e == '物件追加') {
              if (add.includes(name)) {
                return true
              }
            } else if (e == '契約変更') {
              if (retire1.includes(name)) {
                return true
              }
            } else if (e == '退職') {
              if (retire2.includes(name)) {
                return true
              }
            } else if (e == 'その他変更') {
              if (other.includes(name)) {
                return true
              }
            } else if (e == '社員入社') {
              if (enterPer.includes(name)) {
                return true
              }
            } else if (e == '社員退職') {
              if (retirePer.includes(name)) {
                return true
              }
            }
          }
          return false
        }
      },

      /**
       * 携帯番号入力形式確認
       */
      errMobile() {
        if (this.isShow('携帯電話') && this.requestPost.employmentMobile) {
          const pattern = /^[0-9]{3}-[0-9]{4}-[0-9]{4}$/
          //入力値が正しいか
          if (!pattern.test(this.requestPost.employmentMobile)) {
            return '【3桁-4桁-4桁】の形式で入力してください。'
          }
        }
        return ''
      },

      /**
       * 背景色取得
       */
      getBgColor() {
        return (row, val) => {
          let tar = val + 'BgColor'
          if (row[tar]) {
            return row[tar]
          }
          return ''
        }
      },

      /**
       * 少数の表示範囲
       */
      getDecimalPlace() {
        return (val) => {
          if (val && val.length) {
            const num = String(val).split('.')
            if (num[1]) {
              return num[1].length
            } else {
              return 0
            }
          }
          return 0
        }
      }
    },

    async created() {
      // 清掃員リスト取得
      this.getEmploymentNameList()
      // 物件リスト取得
      await this.getAllEmploymentBuildingList()
      this.cleateEmploymentBuildingList()
    },

    methods: {
      /**
       * 社員の名札のモーダルを開く（ユーザーマスタに登録済みの人から選ぶ）
       */
      openNameplate() {
        this.nameplateOpen++
        this.nameplateShow = true
      },

      onKeyPressTel(event) {
        // Allow numbers (charCode 48-57) and dash (charCode 45)
        if ((event.charCode >= 48 && event.charCode <= 57) ||  event.charCode === 45 ) {
          return true;
        } else {
          event.preventDefault(); // Prevent any other character from being entered
        }
      },

      /**
       * 生年月日から年齢を取得
       */
      async ageCalculation(){
        if (!this.requestPost.employmentBirthDay) {
          this.requestPost.employmentAge = ''
        } else {
          var birthday = this.requestPost.employmentBirthDay.split("-")
          var birth = moment().year(birthday[0]).month(birthday[1] - 1).date(birthday[2])
          this.requestPost.employmentAge = String(moment().diff(birth, 'years'))
        }
      },

      /**
       * 入力チェック
       */
      async validation() {
        if (this.errMobile) {
          await dialogs.showInfoDialog('携帯番号', '【3桁-4桁-4桁】の形式で入力してください。')
          return false
        }

        // 配列、文字列
        const valStr = [
          { item: 'employmentClass', name: '種別' }
          ,{ item: 'modifyType', name: '変更もしくは終了' }
          ,{ item: 'employmentHireDate', name: '入社日' }
          ,{ item: 'employmentRetirementDate', name: '退職日' }
          ,{ item: 'employmentRetirementDate', name: '変更日 ' } // もう1つの変更日と見分けがつくように半角スペースを入れる（契約変更用）仕様変更になったため
          ,{ item: 'employmentName', name: '氏名' }
          ,{ item: 'employmentKana', name: 'フリガナ' }
          ,{ item: 'employmentBirthDay', name: '生年月日' }
          ,{ item: 'employmentAge', name: '年齢' }
          ,{ item: 'employmentSex', name: '性別' }
          ,{ item: 'employmentPostCode', name: '郵便番号' }
          ,{ item: 'employmentAddress1', name: '住所１' }
          ,{ item: 'employmentMobile', name: '携帯電話' }
          ,{ item: 'employmentBuildingName', name: '物件名' }
          ,{ item: 'employmentChangedDate', name: '変更日' }
          ,{ item: 'employmentArea', name: 'エリア' }
          ,{ item: 'employmentCustomer', name: '得意先名' }
          ,{ item: 'employmentWorkTask', name: '作業内容' }
          ,{ item: 'employmentHourlyWage', name: '時給' }
          ,{ item: 'employmentTrainType', name: '電車 区分' }
          ,{ item: 'employmentTrainExpenses', name: '電車 交通費' }
          ,{ item: 'employmentBusType', name: 'バス 区分' }
          ,{ item: 'employmentBusExpenses', name: 'バス 交通費' }
          ,{ item: 'employmentParkingType', name: '駐輪 区分' }
          ,{ item: 'employmentParkingExpenses', name: '駐輪 交通費' }
          ,{ item: 'employmentAppliedWork' }
          ,{ item: 'employmentHolidayType', name: '祝日区分' }
          ,{ item: 'employmentTrashRemoval', name: 'ゴミ搬出' }
          ,{ item: 'employmentMaterial', name: '必要な書類' }
          ,{ item: 'employmentDepartmentId', name: '部署' }
          ,{ item: 'employmentCompanion', name: '同行者' }
          ,{ item: 'employmentWeekly', name: '週休●日制' }
          ,{ item: 'employmentPublicHoliday', name: '公休日' }
          ,{ item: 'employmentMoving', name: '引越し費用' }
          ,{ item: 'employmentParkingCorporation', name: '駐車場（法人契約）' }
          ,{ item: 'employmentParkingPrivate', name: '駐車場（個人契約）' }
          ,{ item: 'employmentMail', name: 'メールアドレス' }
          ,{ item: 'employmentRetirementDate', name: '退職日（有給消化後）' }
          ,{ item: 'employmentWorkEndDate', name: '最終勤務日' }
          ,{ item: 'employmentParkingStatus', name: '駐車場契約状況' }
        ]

        for (let i = 0; i < valStr.length; i++) {
          const s = valStr[i]
          let res = { result: true, message: '' }
          // 勤務曜日、勤務時間の場合
          if (s.item == 'employmentAppliedWork') {
            // 項目自体が無いデータ（社員など）があるので空配列として扱う
            const appliedWork = this.requestPost[s.item] || []
            for (let j = 0; j < appliedWork.length; j++) {
              const tar = appliedWork[j]
              // 勤務曜日
              res = this.requireValidateArr2(tar.days, 'ご応募いただいた勤務曜日')
              if (!res.result) {
                await dialogs.showInfoDialog('入力確認', res.message, 'OK')
                return false
              }
              // 開始時間
              res = this.requireValidateArr2(tar.startTime, '勤務時間')
              if (!res.result) {
                await dialogs.showInfoDialog('入力確認', res.message, 'OK')
                return false
              }
              // 終了時間
              res = this.requireValidateArr2(tar.endTime, '勤務時間')
              if (!res.result) {
                await dialogs.showInfoDialog('入力確認', res.message, 'OK')
                return false
              }
            }
          } else {
            // 配列
            if (Array.isArray(this.requestPost[s.item])) {
              res = this.requireValidateArr(s.item, s.name)

            // 文字列
            } else {
              res = this.requireValidateStr(s.item, s.name)
            }
          }

          if (!res.result) {
            await dialogs.showInfoDialog('入力確認', res.message, 'OK')
            return false
          }
        }

        // オブジェクト
        const valObj = [
          { item: 'employmentDocument', name: '履歴書' }
        ]
        for (let i = 0; i < valObj.length; i++) {
          const a = valObj[i]
          let res = {}
          res = this.requireValidateAttach(a.item, a.name)
          if (!res.result) {
            await dialogs.showInfoDialog('入力確認', res.message, 'OK')
            return false
          }
        }

        // 休憩時間の確認
        const work = this.requestPost.employmentAppliedWork || []
        for (let k = 0; k < work.length; k++) {
          const w = work[k]
          const wh = this.getWorkingHours(k)
          const br = utils.getHours(w.startBreakTime || '', w.endBreakTime || '')
          // 実働時間が6時間以上の場合
          if (wh >= 6) {
            if (!br) {
              let ds = await dialogs.showConfirmDialog((k + 1) + '番目の休憩時間はよろしいでしょうか', '勤務時間が6時間以上になっていますが、休憩時間は0時間でよろしいでしょうか？')
              if (ds != 'YES') {
                return
              }
            }
          } else {
            if (br) {
              await dialogs.showErrorDialog((k + 1) + '番目の休憩時間', '勤務時間が6時間未満ですが、休憩時間が入力されています。')
              return
            }
          }
        }

        // 公休日の確認
        if (this.isRequired('公休日') && this.requestPost.employmentWeekly && this.requestPost.employmentWeekly.length) {
          const weekNum = Number(this.requestPost.employmentWeekly[0].replace(/[^0-9]/g, ''))
          if (this.requestPost.employmentPublicHoliday.length != weekNum) {
            let text = 'つ選択しています。'
            if (this.requestPost.employmentPublicHoliday.length < weekNum) {
              text = 'つしか選択していません。'
            }
            const week = await dialogs.showConfirmDialog('公休日の確認', `${this.requestPost.employmentWeekly[0]} ですが、公休日を${this.requestPost.employmentPublicHoliday.length + text}\r\nよろしいでしょうか？`)
            if (week != 'YES') {
              return false
            }
          }
        }

        // 契約変更, 退職の契約情報確認
        if (this.requestPost.employmentClass && this.requestPost.employmentClass[0]
          && this.requestPost.employmentClass[0].indexOf('契約変更') > -1
          && this.requestPost.employmentStaffNumber && this.requestPost.contractList && this.requestPost.contractList.length > 0) {

            for (let cidx = 0; cidx < this.requestPost.contractList.length; cidx++) {
              // 入力チェック(契約 週項目)
              if (!await this.validationContractWeek(this.requestPost.contractList[cidx], cidx)) {
                return false
              }

              // 賃金 未入力
              if (this.requestPost.contractList[cidx].iKubunWage.length == 0) {
                await dialogs.showErrorDialog('契約物件（' + (cidx + 1) + '）', '賃金区分が未入力です。')
                return false
              }
              if (Number(this.requestPost.contractList[cidx].iBasicWage) == 0) {
                await dialogs.showErrorDialog('契約物件（' + (cidx + 1) + '）', '賃金が未入力です。')
                return false
              }

              // 運賃 区分、金額のいづれか未入力
              if (this.requestPost.contractList[cidx].iKubunTrain > 0 && Number(this.requestPost.contractList[cidx].iFareTrain) == 0) {
                await dialogs.showErrorDialog('契約物件（' + (cidx + 1) + '）' + ' 電車', '金額を入力してください。')
                return false
              }
              if (this.requestPost.contractList[cidx].iKubunTrain == 0 && Number(this.requestPost.contractList[cidx].iFareTrain) > 0) {
                await dialogs.showErrorDialog('契約物件（' + (cidx + 1) + '）' + ' 電車', '区分を入力してください。')
                return false
              }
              if (this.requestPost.contractList[cidx].iKubunBus > 0 && Number(this.requestPost.contractList[cidx].iFareBus) == 0) {
                await dialogs.showErrorDialog('契約物件（' + (cidx + 1) + '）' + ' バス', '金額を入力してください。')
                return false
              }
              if (this.requestPost.contractList[cidx].iKubunBus == 0 && Number(this.requestPost.contractList[cidx].iFareBus) > 0) {
                await dialogs.showErrorDialog('契約物件（' + (cidx + 1) + '）' + ' バス', '区分を入力してください。')
                return false
              }
              if (this.requestPost.contractList[cidx].iKubunBicycleParking > 0 && Number(this.requestPost.contractList[cidx].iFareBicycleParking) == 0) {
                await dialogs.showErrorDialog('契約物件（' + (cidx + 1) + '）' + ' 駐輪', '金額を入力してください。')
                return false
              }
              if (this.requestPost.contractList[cidx].iKubunBicycleParking == 0 && Number(this.requestPost.contractList[cidx].iFareBicycleParking) > 0) {
                await dialogs.showErrorDialog('契約物件（' + (cidx + 1) + '）' + ' 駐輪', '区分を入力してください。')
                return false
              }
            }
        }

        // 清掃員の場合
        if (!this.requestPost.employmentRegularStaff) {
          if (this.isShow('生年月日')) {
            this.ageCalculation()
            const age = Number(this.requestPost.employmentAge)
            if (age < 10 || age >= 100) {
              await dialogs.showErrorDialog('生年月日をご確認ください', `年齢が${age}歳 になっています。\r\n生年月日に間違いがないかご確認ください。`)
              return false
            }
          }
          if (this.isRequired('時給')) {
            await this.limitHourlyWageInput()
            if (!this.requestPost.employmentHourlyWage) {
              return false
            }
          }
        }

        // 正社員で退職の場合
        if (this.requestPost.employmentRegularStaff && this.isShow('退職日（有給消化後）')) {
          // 最終勤務日と退職日が逆
          if (this.requestPost.employmentWorkEndDate > this.requestPost.employmentRetirementDate) {
            await dialogs.showErrorDialog('最終勤務日をご確認ください', '退職日よりも最終勤務日が後になっています。逆ではないでしょうか？')
            return false
          }
          // ユーザーID確認
          if (this.requestPost.employmentUserId) {
            const ul = this.userList.find((u) => {
              return this.requestPost.employmentUserId == u.id
            })
            // ユーザー名とIDが一致しなければIDを空にする
            if (ul && ul.nameStaff != this.requestPost.employmentName) {
              this.requestPost.employmentUserId = ''
            }
          }
          // ユーザーID無し
          if (!this.requestPost.employmentUserId) {
            const ul = this.userList.find((u) => {
              return this.requestPost.employmentName == u.nameStaff
            })
            if (ul && ul[0]) {
              this.requestPost.employmentUserId = ul.id
            } else {
              this.reload++
              await dialogs.showErrorDialog('氏名を再度選択してください', '退職者のユーザーIDが取得できませんでした。再度、氏名のドロップダウンから選択してください。')
              return false
            }
          }
        }

        return true
      },

      /**
       * 入力チェック(契約 週項目)
       */
      async validationContractWeek(contract, idx) {
        let weekJa = [
          '日曜',
          '月曜',
          '火曜',
          '水曜',
          '木曜',
          '金曜',
          '土曜',
        ]
        let week = [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ]

        for (let widx = 0; widx < week.length; widx++) {
          // 勤務時間が未入力の場合
          if (!contract['iWorkingHours' + week[widx]]) {
            await dialogs.showErrorDialog('契約物件（' + (idx + 1) + '） ' + weekJa[widx] + '実働時間 未入力', '実働時間がない場合は、0を入力してください。')
            return false
          }

          // 時間チェック
          if ((contract['iStart' + week[widx]].length > 0 && contract['iStart' + week[widx]].length < 4)
              || (contract['iEnd' + week[widx]].length > 0 && contract['iEnd' + week[widx]].length < 4)) {
            await dialogs.showErrorDialog('契約物件（' + (idx + 1) + '） ' + weekJa[widx] + '勤務時間を確認してください', '勤務時間を正しく入力してください。')
            return false
          }
          // 時間範囲チェック（いずれか未入力）
          if (!((contract['iStart' + week[widx]].length > 0 && contract['iEnd' + week[widx]].length > 0)
            || (contract['iStart' + week[widx]].length == 0 && contract['iEnd' + week[widx]].length == 0))) {
            await dialogs.showErrorDialog('契約物件（' + (idx + 1) + '） ' + weekJa[widx] + '勤務時間が未完成', '勤務時間を正しく入力してください。')
            return false
          }

          // 時間範囲チェック（from to）
          if ((contract['iStart' + week[widx]].length > 0 && contract['iEnd' + week[widx]].length > 0)
            && Number(contract['iStart' + week[widx]].replace(':', '')) >= Number(contract['iEnd' + week[widx]].replace(':', ''))) {
            await dialogs.showErrorDialog('契約物件（' + (idx + 1) + '） ' + weekJa[widx] + '勤務時間が不正', '開始と終了の時間が逆、もしくは同じです。\r\n勤務時間を正しく入力してください。')
            return false
          }

          // 実働時間 チェック
          if (contract['iStart' + week[widx]].length > 0 && Number(contract['iWorkingHours' + week[widx]]) == 0) {
            await dialogs.showErrorDialog('契約物件（' + (idx + 1) + '） ' + weekJa[widx] + '実働時間', '開始・終了時間が入っていますが、実働時間が未入力です。')
            return false
          }

          // 勤務時間 チェック
          if (Number(contract['iWorkingHours' + week[widx]]) > 0 && contract['iStart' + week[widx]].length == 0) {
            await dialogs.showErrorDialog('契約物件（' + (idx + 1) + '） ' + weekJa[widx] + '勤務時間', '実働時間が入っていますが、勤務時間（開始・終了）が未入力です。')
            return false
          }

          // 勤務時間と実働時間の関係
          const wh = Number(contract['iWorkingHours' + week[widx]])
          if (wh > 0) {
            // 開始・終了時間から何時間になるかを取得
            const h = utils.getHours(contract['iStart' + week[widx]], contract['iEnd' + week[widx]])
            // 実働時間の方が多い場合
            if (wh > h) {
              await dialogs.showErrorDialog('契約物件（' + (idx + 1) + '） ' + weekJa[widx] + '実動時間が多い', '開始～終了時間よりも実働時間が多くなっています。\r\n' + `${contract['iStart' + week[widx]]}～${contract['iEnd' + week[widx]]}➡${h}時間拘束`)
              return false
            }
            // 6時間以上の場合、休憩時間を入れているか
            if (h >= 6) {
              if (h - wh < 0.75) {
                await dialogs.showErrorDialog('契約物件（' + (idx + 1) + '） ' + weekJa[widx] + '実動時間', '開始～終了時間で6時間以上拘束しています。\r\n45分以上の休憩を考慮し、実働時間を入力してください。')
                return false
              }
            }
          }
        }

        return true
      },

      /**
       * 郵便番号より住所検索
       */
      addressSearch(){
        var geocoder = new window.google.maps.Geocoder()
        var pattern = /^[0-9]{3}-?[0-9]{4}$/
        if(this.requestPost.employmentPostCode) {
          var postalCode = this.requestPost.employmentPostCode
          if (postalCode) {
            //入力値が正しいか
            if (pattern.test(postalCode)) {
              //住所を取得
              geocoder.geocode ({
                address:postalCode,
                language:"ja",
                region:"jp"
              }, this.addressSearchCb)
            } else {
              alert("入力が3桁-4桁の形式であるか確認してください。")
            }
          }
        } else {
            alert("郵便番号を入力をしてください。")
        }
      },

      /**
       * 郵便番号より住所検索 CallBack
       */
      addressSearchCb(results, status) {
        if (status == window.google.maps.GeocoderStatus.OK) {
          if (results.length > 0){
            if (results[0].geometry) {
              if(results[0].address_components[4].long_name == '日本') {
                this.requestPost.employmentAddress1 = results[0].address_components[3].long_name +
                results[0].address_components[2].long_name + results[0].address_components[1].long_name
                // console.log(this.requestPost.employmentAddress1)
              } else {
                this.requestPost.employmentAddress1 = results[0].address_components[4].long_name +
                results[0].address_components[3].long_name + results[0].address_components[2].long_name +
                results[0].address_components[1].long_name
              }
            }
          }
        } else {
          if (status == window.google.maps.GeocoderStatus.ZERO_RESULTS) {
            alert("郵便番号は見つかりませんでした。")
          } else {
            alert("システムの管理者にお問い合わせください。ステータスコード：" + status)
          }
        }
      },

      /**
       * 住所より郵便番号検索
       */
      postalCodeSearch(){
        var geocoder = new window.google.maps.Geocoder()
        if (!this.requestPost.employmentAddress1 && !this.requestPost.employmentAddress2) {
          alert("住所を入力してください")
          return
        }

          var unionAddress = this.requestPost.employmentAddress1 + this.requestPost.employmentAddress2
          geocoder.geocode({
            address:unionAddress,
            language:"ja",
            region:"jp"
          }, this.postalCodeSearchCb)
      },

      /**
       * 住所より郵便番号検索 CallBack
       */
      postalCodeSearchCb(results, status) {
        //アラート用フラグ
        var flag = false
        var ret = this.requestPost
        if (status == window.google.maps.GeocoderStatus.OK) {
          if (results.length > 0) {
            if (results[0].geometry) {
              var result = results[0].address_components;
              result.forEach(function(returnData) {
                returnData.types.forEach(function(getType) {
                  if (getType == 'postal_code') {
                    // console.log( returnData.long_name)
                    ret.employmentPostCode = returnData.long_name
                    flag = true
                  }
                })
              })
            }
          }
          if (flag == false) {
            alert("郵便番号が見つかりませんでした。")
          }
        } else {
          if (status == window.google.maps.GeocoderStatus.ZERO_RESULTS) {
            alert("郵便番号は見つかりませんでした")
          } else {
            alert("システムの管理者にお問い合わせください。ステータスコード：" + status)
          }
        }
      },

      /**
       * 添付ファイル
       */
      attachmentChange(targetAttachmentName, attachmentInfo) {

        // 面接から履歴書を引き継いでいたので、変更の際はそれをリセット
        delete this.requestPost[targetAttachmentName + '_file_content']
        delete this.requestPost[targetAttachmentName + '_display_file_name']
        delete this.requestPost[targetAttachmentName + '_file_name']

        if (!this.requestPost[targetAttachmentName]) {
          this.requestPost[targetAttachmentName] = helper.createEmptyAttachment()
        }
        if (attachmentInfo) {
          this.requestPost[targetAttachmentName].originalName = attachmentInfo.filename
          this.requestPost[targetAttachmentName].content = attachmentInfo.content
        } else {
          this.requestPost[targetAttachmentName] = helper.createEmptyAttachment()
        }
      },

      /**
       * 賃金の確認
       */
      async limitHourlyWageInput() {
        const err = utils.validateHourlyWage(this.requestPost.employmentHourlyWage)
        if (err) {
          await dialogs.showErrorDialog('賃金', err)
          this.requestPost.employmentHourlyWage = ''
        }
      },

      /**
       * 勤務時間変更イベント
       * @param i index
       */
      getWorkingHours(i) {
        const work = this.requestPost.employmentAppliedWork

        return utils.getHours(work[i].startTime, work[i].endTime)
      },

        /**
       * 勤務曜日・時間 追加ボタン
       */
      addAppliedWork() {
        let add = {
          days: [],
          startTime: '',
          endTime: '',
          startBreakTime: '',
          endBreakTime: ''
        }
        this.requestPost.employmentAppliedWork.push(add)
      },

      /**
       * 勤務曜日・時間 削除ボタン
       */
      removeAppliedWork(idx) {
        this.requestPost.employmentAppliedWork.splice(idx, 1)
      },

      /**
       * 交通費区分変更イベント
       * @param type 区分
       * @param fee 交通費
       */
      changeTrans(type, fee) {
        if (this.requestPost[type] && this.requestPost[type][0] == '無') {
          this.requestPost[fee] = '0'
        } else if (this.requestPost[type] && this.requestPost[type][0] != '無') {
          if (this.requestPost[fee] == '0') {
            this.requestPost[fee] = ''
          }
        }
      },

      /**
       * タイトルをセット
       */
      setTitle() {
        if (this.requestPost.employmentClass && this.requestPost.employmentClass[0] != '新規入社') {
          this.$emit('get-title2', this.requestPost)
        }
      },

      /**
       * 清掃員リスト取得
       */
      async getEmploymentNameList() {
        this.employmentNameList = []
        // 新規入社の場合は取得不要
        if (this.requestPost.employmentClass && this.requestPost.employmentClass[0] == '新規入社') {
          return
        }
        const list = await backend.searchData('akbsTable/getInstructEmploymentStaff', null)
        if (list && list.data.data && list.data.data.length) {
          this.employmentNameList = list.data.data
        }
      },

      /**
       * 清掃員名選択
       */
      async staffSelected(e) {
        // 清掃員の場合
        if (!this.requestPost.employmentRegularStaff) {
          this.requestPost.employmentStaffNumber = e.staffDailyCleaning
          this.requestPost.employmentMobile = e.numberMobilePhoneStaff
          this.requestPost.birthday = e.birthday
          this.requestPost.age = e.age

          await this.getEmploymentBuildingList(e)
        } else {
          this.requestPost.employmentKana = e.kana
          this.requestPost.employmentName = e.nameStaff
          this.requestPost.employmentUserId = e.id
        }
        this.setTitle()
        this.reload++
      },

      /**
       * 清掃員名変更
       */
      async staffChanged() {
        if (!this.requestPost.employmentName) {
          this.requestPost.employmentStaffNumber = ''
          this.requestPost.employmentMobile = ''
          this.requestPost.employmentUserId = ''
          this.requestPost.birthday = ''
          this.requestPost.age = ''

          await this.getEmploymentBuildingList()
        }
        this.setTitle()
        this.reload++
      },

      /**
       * 物件リスト取得
       */
      async getEmploymentBuildingList(tar) {
        // 種別が契約変更、もしくは退職
        if (this.requestPost.employmentClass && this.requestPost.employmentClass[0]
          && (this.requestPost.employmentClass[0].indexOf('契約変更') > -1 || this.requestPost.employmentClass[0].indexOf('退職') > -1)
          && this.requestPost.employmentStaffNumber) {
          const param = {
            staff: this.requestPost.employmentName,
            staffDailyCleaning: this.requestPost.employmentStaffNumber
          }
          if (tar && tar.nameStaff) {
            param.staff = tar.nameStaff
          }
          if (tar && tar.nameStaff) {
            param.staffDailyCleaning = tar.staffDailyCleaning
          }
          const list = await backend.searchData('akbsTable/getSiteData', param)
          // 現在、担当している物件がある場合
          if (list && list.data.list && list.data.list.length) {
            this.employmentBuildingList = list.data.list
            if (tar) this.requestPost.contractList = this.convertToContractList(list.data.contract)
            return
          }
        }
        this.requestPost.contractList = []
        this.requestPost.changeData = {}
        this.employmentBuildingList = utils.clone(this.allEmploymentBuildingList)
      },

      /**
       * 編集時の担当物件リスト取得
       */
      async cleateEmploymentBuildingList() {
        // 種別が契約変更、もしくは退職
        if (this.requestPost.employmentClass && this.requestPost.employmentClass[0]
          && (this.requestPost.employmentClass[0].indexOf('契約変更') > -1 || this.requestPost.employmentClass[0].indexOf('退職') > -1)
          && this.requestPost.employmentStaffNumber) {
          const param = {
            staff: this.requestPost.employmentName,
            staffDailyCleaning: this.requestPost.employmentStaffNumber
          }
          const list = await backend.searchData('akbsTable/getSiteData', param)
          // 現在、担当している物件がある場合
          if (list && list.data.list && list.data.list.length) {
            this.employmentBuildingList = list.data.list
            return
          }
        }
        this.employmentBuildingList = utils.clone(this.allEmploymentBuildingList)
      },

      /**
       * 物件リスト全取得
       */
      async getAllEmploymentBuildingList() {
        // API: akbsTable/getSiteList（作業明細にあり契約が終わっていない物件）
        const list = await backend.searchData('akbsTable/getSiteList', null)
        if (list && list.data.data && list.data.data.length) {
          this.allEmploymentBuildingList = list.data.data
        } else {
          this.allEmploymentBuildingList = []
        }
      },

      /**
       * 種別変更
       */
      async changeEmploymentClass(e) {
        await this.getEmploymentBuildingList(e)
        this.setTitle()

        // メイン期限設定
        this.setLimitDate()
      },

      /**
       * 期限設定
       */
      setLimitDate() {
        if (this.requestPost.employmentClass && this.requestPost.employmentClass.length) {
          // 正社員の場合
          if (this.requestPost.employmentRegularStaff) {
            // 入社の場合、期限をセット
            if (this.requestPost.employmentClass[0] == '社員入社' && this.requestPost.employmentHireDate) {
              this.requestPost.kubunLimit = 2
              this.requestPost.limitDate = moment(this.requestPost.employmentHireDate).add(6, 'months').format('YYYY-MM-DD')

            // 退社の場合、期限をセット
            } else if (this.requestPost.employmentClass[0] == '社員退職' && this.requestPost.employmentRetirementDate) {
              this.requestPost.kubunLimit = 2
              this.requestPost.limitDate = moment(this.requestPost.employmentRetirementDate).add(1, 'months').format('YYYY-MM-26')
            }

          // DCの場合
          } else {
            if (this.requestPost.employmentClass[0] == '退職' && this.requestPost.employmentRetirementDate) {
              // 給料は翌月に生産されるため、退職日の翌月20日に設定
              this.requestPost.limitDate = moment(this.requestPost.employmentRetirementDate).add(1, 'months').format('YYYY-MM-20')
              // 期限日が1か月後なら長期タスク
              this.requestPost.kubunLimit = utils.getKubunLimit(this.requestPost.limitDate)
            }

          }
        }
        this.reload++
      },

      /**
       * 清掃員の新規入社
       */
      newEnterForCD() {
        if (!this.requestPost.employmentRegularStaff) {
          // 選択させる
          this.$emit('newEnterForCD')
        }
      },

      /**
       * 物件選択モーダルopen
       */
      openSiteModal() {
        this.siteModal = true
      },

      /**
       * 物件選択モーダルclose
       */
      siteSelected(target) {
        this.requestPost.employmentSiteCode = target.cdSite
        this.requestPost.employmentBuildingName = target.nameSite
        this.requestPost.clientCode = target.clientCode
        this.requestPost.employmentCustomer = target.nameCustomer
        if (target.nameCustomer2) {
          this.requestPost.employmentCustomer += ' ' + target.nameCustomer2
        }
        this.requestPost.employmentSiteAddress = target.address
        // 得意先一覧からFAX番号を取得
        this.requestPost.clientFax = ''
        if (target.clientCode && this.clientLists) {
          const client = this.clientLists.find((c) => {
            return c.clientCode == target.clientCode
          })
          if (client && client.clientFax) {
            this.requestPost.clientFax = client.clientFax
          }
        }
        // 作業内容区分取得
        let employmentWorkTask = []
        let cw = null
        if (target.cdContentsWork) {
          cw = target.cdContentsWork
        } else if (target.cdContentsWorkContract) {
          cw = target.cdContentsWorkContract
        }
        if (cw) {
          const obj = constants.WORK_SELECTIONS.find((row) => {
            return row.code == cw
          })
          if (obj && obj.text) {
            employmentWorkTask = [obj.text]
          }
        }
        if (employmentWorkTask.length) {
          this.requestPost.employmentWorkTask = employmentWorkTask
        }

        this.getArea()
        this.setTitle()
        this.siteModal = false
      },

      /**
       * 物件変更イベント
       */
      siteChanged() {
        if (!this.requestPost.employmentBuildingName) {
          this.requestPost.employmentSiteCode = ''
          this.requestPost.employmentBuildingName = ''
          this.requestPost.employmentCustomer = ''
          this.requestPost.clientCode = ''
          this.requestPost.clientFax = ''
          this.requestPost.employmentSiteAddress = ''
          this.requestPost.employmentArea = ''
        }
        this.setTitle()
      },

      /**
       * 住所からエリアを取得
       */
      getArea() {
        if (this.requestPost.employmentSiteAddress) {
          for (let i = 0; i < this.areaSelections.length; i++) {
            const a = this.areaSelections[i]
            if (a && this.requestPost.employmentSiteAddress.indexOf(a) > -1) {
              this.requestPost.employmentArea = a
              return
            }
          }
        }

        this.requestPost.employmentArea = ''
      },

      /**
       * 「得意先の選択」モーダルでの得意先選択イベント
       */
      modalClientSelected(target) {
        this.clientModal = false
        this.clientSelected(target)
      },

      /**
       * 得意先選択イベント
       */
      clientSelected(selectedClient) {
        // 選択したお客様情報を表示
        this.requestPost.employmentCustomer = selectedClient.clientName + ' ' + selectedClient.clientDepartmentName

        // リクエストポストのデータにお客様コードを追加
        this.requestPost.clientCode = selectedClient.clientCode

        // FAX番号
        this.requestPost.clientFax = selectedClient.clientFax
        // console.log(selectedClient)
      },

      /**
       * 得意先変更イベント
       * @param clientName 入力値
       */
      clientNameChanged(clientName) {
        if (clientName === '') {
          this.requestPost.employmentCustomer = ''
          this.requestPost.clientCode = ''
          this.requestPost.clientFax = ''
        }
      },

      /**
       * 得意先へ連絡モーダルopen
       * @param isMail メールか否か
       */
      async opentMessageForClient(isMail) {
        this.client = {}
        this.isMail = isMail
        // 種別確認
        if (this.requestPost.employmentClass && this.requestPost.employmentClass[0]) {
          // 対象日確認
          if (!this.requireValidateStr('employmentHireDate', '入社日').result) {
            await dialogs.showErrorDialog('入社日未入力', this.requireValidateStr('employmentHireDate', '入社日').message)
            return
          }
          if (!this.requireValidateStr('employmentRetirementDate', '退職日').result) {
            await dialogs.showErrorDialog('退社日未入力', this.requireValidateStr('employmentRetirementDate', '退職日').message)
            return
          }
          if (!this.requireValidateStr('employmentRetirementDate', '変更日 ').result) {
            await dialogs.showErrorDialog('変更日未入力', this.requireValidateStr('employmentRetirementDate', '変更日 ').message)
            return
          }
        } else {
          await dialogs.showErrorDialog('種別未選択', '種別を選択して下さい。')
          return
        }
        // 得意先情報を取得
        if (this.requestPost.clientCode) {
          if (this.clientLists) {
            const client = this.clientLists.find((c) => {
              return c.clientCode == this.requestPost.clientCode
            })
            if (client) {
              let res = false
              const name = client.clientName + ' ' + client.clientDepartmentName
              // コードから取得した名前と画面上の名前が正しいか
              if (name == this.requestPost.employmentCustomer) {
                res = true
                this.client = client
              // 支店名がない場合、もう一度確認
              } else if (!client.clientDepartmentName) {
                if (client.clientName == this.requestPost.employmentCustomer) {
                  res = true
                  this.client = client
                }
              }
              // 得意先名と得意先コードが合っていない
              if (!res) {
                await dialogs.showErrorDialog('得意先名を再度選択クリックしてください。', '得意先情報の取得が不十分です。\r\n再度、得意先名のドロップダウンを選択クリックしてください。')
                return
              }
            }
          } else {
            alert('エラーが発生しました。')
          }
        } else {
          await dialogs.showErrorDialog('得意先名を再度選択クリックしてください。', '得意先情報の取得が不十分です。\r\n再度、得意先名のドロップダウンを選択クリックしてください。')
          return
        }
        this.messageForClient = true
      },

      async resignationDL() {
        if (!this.requestPost.employmentRetirementDate) {
          await dialogs.showErrorDialog('退職日がありません', '退職日を入力してください。')
          return
        }
        this.loading = true
        try {
          const res = await backend.postBlob2('employment/resignationTemp', { day: this.requestPost.employmentRetirementDate })
          const uint8Array = res.data
          const blob = new Blob([uint8Array], { type : "application/pdf" })
          // const url = URL.createObjectURL(blob)
          // let a = document.createElement('a')
          // a.href = url
          // a.download = '退職届' + this.requestPost.employmentRetirementDate + '.pdf'
          // a.click()
          // a.remove()
          window.open(URL.createObjectURL(blob))
          this.loading = false
        } catch (e) {
          console.log(e)
          alert(e)
          this.loading = false
        }
      },

      /**
       * 契約リスト 変換
       */
      convertToContractList(employments) {
        this.requestPost.changeData = {}
        var list = []
        for (const val of employments) {
          list.push({
            nameSite: val.nameSite,
            cdSite: val.cdSite,
            cdContract: val.cdContract,
            nameCustomer: val.nameCustomerSi,
            nameCustomer2: val.nameCustomer2Si,

            attendanceMonday: val.attendanceMonday,
            workingHoursMonday: val.workingHoursMonday,
            startMonday: val.startMonday,
            endMonday: val.endMonday,
            attendanceTuesday: val.attendanceTuesday,
            workingHoursTuesday: val.workingHoursTuesday,
            startTuesday: val.startTuesday,
            endTuesday: val.endTuesday,
            attendanceWednesday: val.attendanceWednesday,
            workingHoursWednesday: val.workingHoursWednesday,
            startWednesday: val.startWednesday,
            endWednesday: val.endWednesday,
            attendanceThursday: val.attendanceThursday,
            workingHoursThursday: val.workingHoursThursday,
            startThursday: val.startThursday,
            endThursday: val.endThursday,
            attendanceFriday: val.attendanceFriday,
            workingHoursFriday: val.workingHoursFriday,
            startFriday: val.startFriday,
            endFriday: val.endFriday,
            attendanceSaturday: val.attendanceSaturday,
            workingHoursSaturday: val.workingHoursSaturday,
            startSaturday: val.startSaturday,
            endSaturday: val.endSaturday,
            attendanceSunday: val.attendanceSunday,
            workingHoursSunday: val.workingHoursSunday,
            startSunday: val.startSunday,
            endSunday: val.endSunday,

            kubunWage: val.kubunWage,
            basicWage: val.basicWage,
            kubunTrain: val.kubunTrain,
            fareTrain: val.fareTrain,
            kubunBus: val.kubunBus,
            fareBus: val.fareBus,
            kubunBicycleParking: val.kubunBicycleParking,
            fareBicycleParking: val.fareBicycleParking,

            attendanceMondayBgColor: '',
            workingHoursMondayBgColor: '',
            startMondayBgColor: '',
            endMondayBgColor: '',
            attendanceTuesdayBgColor: '',
            workingHoursTuesdayBgColor: '',
            startTuesdayBgColor: '',
            endTuesdayBgColor: '',
            attendanceWednesdayBgColor: '',
            workingHoursWednesdayBgColor: '',
            startWednesdayBgColor: '',
            endWednesdayBgColor: '',
            attendanceThursdayBgColor: '',
            workingHoursThursdayBgColor: '',
            startThursdayBgColor: '',
            endThursdayBgColor: '',
            attendanceFridayBgColor: '',
            workingHoursFridayBgColor: '',
            startFridayBgColor: '',
            endFridayBgColor: '',
            attendanceSaturdayBgColor: '',
            workingHoursSaturdayBgColor: '',
            startSaturdayBgColor: '',
            endSaturdayBgColor: '',
            attendanceSundayBgColor: '',
            workingHoursSundayBgColor: '',
            startSundayBgColor: '',
            endSundayBgColor: '',

            kubunWageBgColor: '',
            basicWageBgColor: '',
            kubunTrainBgColor: '',
            fareTrainBgColor: '',
            kubunBusBgColor: '',
            fareBusBgColor: '',
            kubunBicycleParkingBgColor: '',
            fareBicycleParkingBgColor: '',

            // 以降入力用項目
            iAttendanceMonday: val.attendanceMonday,
            iWorkingHoursMonday: val.workingHoursMonday,
            iStartMonday: val.startMonday,
            iEndMonday: val.endMonday,
            iAttendanceTuesday: val.attendanceTuesday,
            iWorkingHoursTuesday: val.workingHoursTuesday,
            iStartTuesday: val.startTuesday,
            iEndTuesday: val.endTuesday,
            iAttendanceWednesday: val.attendanceWednesday,
            iWorkingHoursWednesday: val.workingHoursWednesday,
            iStartWednesday: val.startWednesday,
            iEndWednesday: val.endWednesday,
            iAttendanceThursday: val.attendanceThursday,
            iWorkingHoursThursday: val.workingHoursThursday,
            iStartThursday: val.startThursday,
            iEndThursday: val.endThursday,
            iAttendanceFriday: val.attendanceFriday,
            iWorkingHoursFriday: val.workingHoursFriday,
            iStartFriday: val.startFriday,
            iEndFriday: val.endFriday,
            iAttendanceSaturday: val.attendanceSaturday,
            iWorkingHoursSaturday: val.workingHoursSaturday,
            iStartSaturday: val.startSaturday,
            iEndSaturday: val.endSaturday,
            iAttendanceSunday: val.attendanceSunday,
            iWorkingHoursSunday: val.workingHoursSunday,
            iStartSunday: val.startSunday,
            iEndSunday: val.endSunday,

            iKubunWage: val.kubunWage,
            iBasicWage: val.basicWage,
            iKubunTrain: val.kubunTrain,
            iFareTrain: val.fareTrain,
            iKubunBus: val.kubunBus,
            iFareBus: val.fareBus,
            iKubunBicycleParking: val.kubunBicycleParking,
            iFareBicycleParking: val.fareBicycleParking
          })
        }
        return list
      },

      /**
       * 契約 項目背景色クラス 取得
       */
      getContractBGColor(contract, propName, ipropName) {
        // 出勤形態で毎週の場合
        if (propName.indexOf('attendance') > -1 && contract[propName] == '' && contract[ipropName] == '00') {
          return 'i-bg-white'
        }
        // 値が変わっている場合
        if (contract[propName] != contract[ipropName]) {
          this.reload++
          return 'i-bg-yellow-200'

        // 値が変わっていない場合
        } else {
          return 'i-bg-white'
        }
      },

      /**
       * 契約 運賃項目区分 change イベント
       */
      changeFareKubun(contract, propName, kubun, fare) {
        // 区分を未選択にした場合、金額をクリア
        if (contract[kubun] == '0') {
          contract[fare] = '0'
          const fareProp = fare.replace('iF', 'f')
          contract[fareProp + 'BgColor'] = this.getContractBGColor(contract, fareProp, fare)
        }
        contract[propName + 'BgColor'] = this.getContractBGColor(contract, propName, kubun)
        this.getChangePoint()
        this.reload++
      },

      /**
       * 契約 変更項目 change イベント
       */
      changeContractChangeItem(contract, propName, ipropName) {
        contract[propName + 'BgColor'] = this.getContractBGColor(contract, propName, ipropName)
        this.getChangePoint()
        this.reload++
      },

      /**
       * 変更箇所一覧を生成
       */
      getChangePoint() {
        let list = []
        for (let i = 0; i < this.requestPost.contractList.length; i++) {
          const row = this.requestPost.contractList[i]
          const ky = Object.keys(row)
          if (ky && ky.length) {
            for (let j = 0; j < ky.length; j++) {
              const k = ky[j]
              // 変更ある場合
              if (k.indexOf('BgColor') > -1 && row[k] == 'i-bg-yellow-200') {
                const names = this.getPropName(k, i, row.nameSite)
                let flg = false
                for (let idx = 0; idx < list.length; idx++) {
                  const l = list[idx]
                  if (l.site == names.site) {
                    flg = true
                    if (!l.list) {
                      l.list = []
                    }
                    l.list.push(names.name)
                  }
                }
                if (!flg) {
                  list.push({ site: names.site, list: [names.name] })
                }
              }
            }
          }
        }
        this.requestPost.changeData = list
      },

      /**
       * プロパティ名を取得
       */
      getPropName(key, i, site) {
        const list = [
          { v1: 'Sunday', v2: '日曜' },
          { v1: 'Monday', v2: '月曜' },
          { v1: 'Tuesday', v2: '火曜' },
          { v1: 'Wednesday', v2: '水曜' },
          { v1: 'Thursday', v2: '木曜' },
          { v1: 'Friday', v2: '金曜' },
          { v1: 'Saturday', v2: '土曜' },
          { v1: 'attendance', v2: ' 出勤形態' },
          { v1: 'workingHours', v2: ' 実働時間' },
          { v1: 'start', v2: ' 開始時間' },
          { v1: 'end', v2: ' 終了時間' },
          { v1: 'Wage', v2: '賃金' },
          { v1: 'Train', v2: '電車' },
          { v1: 'Bus', v2: 'バス' },
          { v1: 'Bicycle', v2: '駐輪' },
          { v1: 'kubun', v2: ' 区分' },
          { v1: 'fare', v2: ' 金額' }
        ]
        // 項目名を取得
        let name = ''
        for (let i = 0; i < list.length; i++) {
          const e = list[i]
          if (key.indexOf(e.v1) > -1) {
            if (e.v1 == 'end' && key.indexOf('attendance') > -1) {
              continue
            }
            name += e.v2
          }
        }
        return { site: '契約物件(' + (i + 1) + ') ' + site, name }
      },

      /**
       * 契約変更の種別
       */
      clickModifyType(val) {
        if (this.referenceMode) {
          return
        }
        this.requestPost.modifyType = val
        this.reload++
      },

      // calcTotalWorkHours(works) {
      //   if (!works || !works.length) {
      //     return 0
      //   }

        
      // }
    }
  }
</script>

<style scoped>
  .five-selection >>> button[type=button] {
    width: 19.8% !important;
  }

  .six-selection >>> button[type=button] {
    width: 16.2% !important;
  }

  .seven-selection >>> button[type=button] {
    width: 14% !important;
  }

  #employmentAppliedWorkDays >>> button[type=button] {
    width: 12% !important;
  }

  .time div #hour-input {
    width: 65px !important;
  }

  .time div #minute-input {
    width: 65px !important;
  }

  .contract-frame {
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 15px;
  }

  .contract-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .hr-week {
    background-color: lightgray;
    height: 1px;
    border: none;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .working-hours {
    width: 100%;
  }

  .i-bg-yellow-200 >>> input,
  select.i-bg-yellow-200,
  .i-bg-yellow-200 >>> input[type=text] {
    background-color: #FFF59D !important;
  }

  .i-bg-white >>> input,
  select.i-bg-white {
    background-color: #fff;
  }
</style>